// import React, { useEffect, useState, useRef } from 'react';
// import { SecondaryBase } from '../Commons/SecondaryBase';
// import { useFloatMessage, MESSAGE_TYPE } from '../../Providers/FloatMessage';
// import { 
//     GetLineup, 
//     SaveLineup, 
//     GetSportModes, 
//     CalculateFormationPositions,
//     TriggerPresentation
// } from '../../../utilities/BL/Lineup';
// import { GetTeams, GetPlayersByTeam } from '../../../utilities/BL/SportPlayer';

// const Lineup = ({ getOutOfTheDynamic }) => {
//     const { showMessage } = useFloatMessage();

//     // --- ESTADOS ---
//     const [sportConfig, setSportConfig] = useState(null);
//     const [teamType, setTeamType] = useState('Local');
//     const [gameMode, setGameMode] = useState('soccer');
//     const [teams, setTeams] = useState([]);
//     const [availablePlayers, setAvailablePlayers] = useState([]);
//     const [teamId, setTeamId] = useState('');
//     const [formation, setFormation] = useState('');
//     const [kitColor, setKitColor] = useState('#1e293b');
//     const [managerName, setManagerName] = useState('Director Técnico');
//     const [pitchPlayers, setPitchPlayers] = useState([]);
    
//     // --- ESTADOS ENDZONE ---
//     const [leftEndzoneText, setLeftEndzoneText] = useState('LOCAL');
//     const [rightEndzoneText, setRightEndzoneText] = useState('VISITA');
//     const [leftEndzoneLogoUrl, setLeftEndzoneLogoUrl] = useState('');
//     const [rightEndzoneLogoUrl, setRightEndzoneLogoUrl] = useState('');

//     // --- ESTADO DE SECUENCIA TV ---
//     const [isSequenceRunning, setIsSequenceRunning] = useState(false);
//     const [presentationTime, setPresentationTime] = useState(8); 
//     const sequenceRunningRef = useRef(false);

//     // --- EFECTO DE INICIALIZACIÓN ---
//     useEffect(() => {
//         const init = async () => {
//             try {
//                 const config = await GetSportModes();
//                 if (config) {
//                     setSportConfig(config);
//                     const teamsRes = await GetTeams();
//                     if (teamsRes.success) setTeams(teamsRes.data);
//                     await fetchLineup('Local', config);
//                 }
//             } catch (err) {
//                 console.error("Error inicial:", err);
//             }
//         };
//         init();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//     }, []);

//     const fetchLineup = async (type, config) => {
//         const res = await GetLineup(type);
//         if (res.success && res.data && res.data.teamId) {
//             const data = res.data;
//             setGameMode(data.gameMode || 'soccer');
//             setTeamId(data.teamId);
//             setFormation(data.formation);
//             setKitColor(data.kitColor || '#1e293b');
//             setManagerName(data.managerName || 'Director Técnico');
//             setLeftEndzoneText(data.leftEndzoneText || 'LOCAL');
//             setRightEndzoneText(data.rightEndzoneText || 'VISITA');
//             setLeftEndzoneLogoUrl(data.leftEndzoneLogoUrl || '');
//             setRightEndzoneLogoUrl(data.rightEndzoneLogoUrl || '');
            
//             await loadTeamRoster(data.teamId);
//             setPitchPlayers(data.players || []);
//         } else if (config && config.length > 0) {
//             const defaultMode = config[0].code;
//             handleGameModeChange(defaultMode, config);
//         }
//     };

//     const loadTeamRoster = async (id) => {
//         if (!id) return;
//         const res = await GetPlayersByTeam(id);
//         if (res.success) setAvailablePlayers(res.data);
//     };

//     const handleGameModeChange = (newMode, config = sportConfig) => {
//         if (pitchPlayers.length > 0 && !window.confirm("Cambiar de deporte reiniciará la pizarra. ¿Continuar?")) return;
        
//         const modeData = config.find(m => m.code === newMode);
//         const firstFormation = Object.keys(modeData.formations)[0];
        
//         setGameMode(newMode);
//         setFormation(firstFormation);
//         setPitchPlayers(CalculateFormationPositions(firstFormation, newMode, config, teamType, []));
//     };

//     const applyFormationTemplate = (formName) => {
//         setFormation(formName);
//         const newPitch = CalculateFormationPositions(formName, gameMode, sportConfig, teamType, pitchPlayers);
//         setPitchPlayers(newPitch);
//     };

//     // --- LÓGICA DE JUGADORES EN PIZARRA (DRAG & DROP Y SELECTORES) ---
//     const updatePitchPlayer = (index, playerId) => {
//         const playerObj = availablePlayers.find(p => p.id === parseInt(playerId));
//         if (!playerObj) return;

//         const newPitch = [...pitchPlayers];
//         newPitch[index] = {
//             ...newPitch[index],
//             playerId: playerObj.id,
//             name: playerObj.name,
//             dorsal: playerObj.dorsal
//         };
//         setPitchPlayers(newPitch);
//     };

//     const setCaptain = (index) => {
//         const newPitch = pitchPlayers.map((p, i) => ({ ...p, isCaptain: i === index }));
//         setPitchPlayers(newPitch);
//     };

//     const handleDragStart = (e, index) => { e.dataTransfer.setData('sourceIndex', index); };

//     const handleDrop = (e, targetIndex) => {
//         const sourceIndex = parseInt(e.dataTransfer.getData('sourceIndex'));
//         if (sourceIndex === targetIndex || isNaN(sourceIndex)) return;

//         const newPitch = [...pitchPlayers];
//         const tempPlayer = { ...newPitch[sourceIndex] };
        
//         newPitch[sourceIndex].playerId = newPitch[targetIndex].playerId;
//         newPitch[sourceIndex].name = newPitch[targetIndex].name;
//         newPitch[sourceIndex].dorsal = newPitch[targetIndex].dorsal;
//         newPitch[sourceIndex].isCaptain = newPitch[targetIndex].isCaptain;

//         newPitch[targetIndex].playerId = tempPlayer.playerId;
//         newPitch[targetIndex].name = tempPlayer.name;
//         newPitch[targetIndex].dorsal = tempPlayer.dorsal;
//         newPitch[targetIndex].isCaptain = tempPlayer.isCaptain;

//         setPitchPlayers(newPitch);
//     };

//     const getPitchStyle = () => {
//         if (gameMode === 'basketball') return { backgroundColor: '#d68743', border: '2px solid white' };
//         if (gameMode === 'flag_football') return { backgroundColor: '#2e5932', border: '2px dashed yellow' };
//         return { backgroundColor: '#1a4d2e', border: '2px solid rgba(255,255,255,0.5)' };
//     };

//     // --- ACCIONES DE GUARDADO Y PRESENTACIÓN ---
//     const handleTeamChange = async (newTeamId) => {
//         setTeamId(newTeamId);
//         if (newTeamId) {
//             await loadTeamRoster(newTeamId);
//         } else {
//             setAvailablePlayers([]);
//         }
//     };

//     const handleSave = async () => {
//         if (pitchPlayers.some(p => !p.playerId)) {
//             showMessage(`Faltan asignar jugadores a las posiciones.`, MESSAGE_TYPE.WARNING);
//             return;
//         }

//         const lineupData = {
//             gameMode, teamId: parseInt(teamId), formation, kitColor, managerName,
//             players: pitchPlayers,
//             leftEndzoneText, rightEndzoneText, leftEndzoneLogoUrl, rightEndzoneLogoUrl
//         };

//         const result = await SaveLineup(lineupData);
//         if (result.success) {
//             showMessage("Alineación guardada y sincronizada", MESSAGE_TYPE.SUCCESS);
//         } else {
//             showMessage("Error al guardar: " + (result.message || "Intenta de nuevo"), MESSAGE_TYPE.ERROR);
//         }
//     };

//     const firePresentation = async (action, playerId = null) => {
//         await TriggerPresentation(action, playerId);
//         if(action !== 'close' && action !== 'hide_board' && action !== 'show_board') {
//             showMessage(`Presentando en pantalla...`, MESSAGE_TYPE.SUCCESS);
//         }
//     };

//     const toggleBoardVisibility = async (show) => {
//         await TriggerPresentation(show ? 'show_board' : 'hide_board');
//         showMessage(show ? "Pizarra VISIBLE en transmisión" : "Pizarra OCULTA en transmisión", MESSAGE_TYPE.SUCCESS);
//     };

//     const runFullSequence = async () => {
//         if (sequenceRunningRef.current) return;
        
//         sequenceRunningRef.current = true;
//         setIsSequenceRunning(true);
//         showMessage("Secuencia Automática Iniciada", MESSAGE_TYPE.SUCCESS);

//         const sortedPlayers = [...pitchPlayers].sort((a, b) => a.positionX - b.positionX);

//         for (let player of sortedPlayers) {
//             if (!sequenceRunningRef.current) break; 
//             if (!player.playerId) continue;
            
//             await TriggerPresentation('show_player', player.playerId);
            
//             for(let i = 0; i < presentationTime; i++) {
//                 if (!sequenceRunningRef.current) break;
//                 await new Promise(resolve => setTimeout(resolve, 1000));
//             }
//         }

//         if (sequenceRunningRef.current) {
//             await TriggerPresentation('show_dt', null);
//             for(let i = 0; i < presentationTime; i++) {
//                 if (!sequenceRunningRef.current) break;
//                 await new Promise(resolve => setTimeout(resolve, 1000));
//             }
//         }

//         if (sequenceRunningRef.current) {
//             await TriggerPresentation('close', null);
//             showMessage("Secuencia Finalizada", MESSAGE_TYPE.SUCCESS);
//         }

//         sequenceRunningRef.current = false;
//         setIsSequenceRunning(false);
//     };

//     const abortSequence = async () => {
//         sequenceRunningRef.current = false; 
//         setIsSequenceRunning(false);
//         await TriggerPresentation('close', null);
//         showMessage("Presentación abortada", MESSAGE_TYPE.WARNING);
//     };

//     // --- RENDER ---
//     if (!sportConfig) return <div className="p-5 text-center text-muted fw-bold">Cargando módulos deportivos...</div>;

//     const currentMode = sportConfig.find(m => m.code === gameMode);

//     return (
//         <SecondaryBase actionToExecute={getOutOfTheDynamic}>
//             <div className="container-fluid pb-5">
//                 <div className="text-center mb-4">
//                     <h3 className="fw-bold"><i className={`bi ${currentMode?.iconClass || 'bi-diagram-3-fill'}`}></i> Súper Lienzo: Alineación Multideporte</h3>
//                     <p className="text-muted small">Configura la táctica y lanza la presentación estelar a la transmisión.</p>
//                 </div>

//                 <div className="row g-4">
//                     {/* COLUMNA IZQUIERDA: Configuración y Master TV */}
//                     <div className="col-lg-4">
//                         <div className="card shadow-sm border-0 rounded-4 mb-4">
//                             <div className="card-header bg-dark text-white fw-bold d-flex justify-content-between align-items-center">
//                                 <span><i className="bi bi-gear-fill"></i> Configuración</span>
//                                 <span className="badge bg-primary">{currentMode?.name || '...'}</span>
//                             </div>
//                             <div className="card-body">
                                
//                                 <div className="mb-3 bg-light p-2 rounded border border-info">
//                                     <label className="form-label small fw-bold text-info-emphasis">Modalidad Deportiva</label>
//                                     <select className="form-select border-info" value={gameMode} onChange={(e) => handleGameModeChange(e.target.value)}>
//                                         {sportConfig.map(mode => (
//                                             <option key={mode.code} value={mode.code}>{mode.name}</option>
//                                         ))}
//                                     </select>
//                                 </div>

//                                 <div className="mb-3">
//                                     <label className="form-label small fw-bold">Tipo de Equipo</label>
//                                     <select className="form-select" value={teamType} onChange={(e) => { setTeamType(e.target.value); fetchLineup(e.target.value); }}>
//                                         <option value="Local">Local</option>
//                                         <option value="Away">Visitante</option>
//                                     </select>
//                                 </div>

//                                 <div className="mb-3">
//                                     <label className="form-label small fw-bold">Seleccionar Equipo de BD</label>
//                                     <select className="form-select" value={teamId} onChange={(e) => handleTeamChange(e.target.value)}>
//                                         <option value="">-- Elige un equipo --</option>
//                                         {teams.map(t => <option key={t.id} value={t.id}>{t.name}</option>)}
//                                     </select>
//                                 </div>

//                                 <div className="mb-3">
//                                     <label className="form-label small fw-bold">Formación ({currentMode?.maxPlayers || 0} Jugadores)</label>
//                                     <select className="form-select" value={formation} onChange={(e) => applyFormationTemplate(e.target.value)}>
//                                         {currentMode?.formations && Object.keys(currentMode.formations).map(f => <option key={f} value={f}>{f}</option>)}
//                                     </select>
//                                 </div>

//                                 <div className="row g-2 mb-3">
//                                     <div className="col-6">
//                                         <label className="form-label small fw-bold">Color Uniforme</label>
//                                         <input type="color" className="form-control form-control-color w-100" value={kitColor} onChange={(e) => setKitColor(e.target.value)} />
//                                     </div>
//                                     <div className="col-6">
//                                         <label className="form-label small fw-bold">Nombre del DT</label>
//                                         <input type="text" className="form-control" value={managerName} onChange={(e) => setManagerName(e.target.value)} placeholder="Ej. Guardiola" />
//                                     </div>
//                                 </div>

//                                 {gameMode === 'flag_football' && (
//                                     <div className="border border-success rounded p-2 mb-3 bg-light">
//                                         <label className="form-label small fw-bold text-success mb-2"><i className="bi bi-flag-fill"></i> Zonas de Anotación (Endzones)</label>
//                                         <div className="row g-2 mb-2">
//                                             <div className="col-6">
//                                                 <input type="text" className="form-control form-control-sm" placeholder="Texto Izq (LOCAL)" value={leftEndzoneText} onChange={e => setLeftEndzoneText(e.target.value)} />
//                                             </div>
//                                             <div className="col-6">
//                                                 <input type="text" className="form-control form-control-sm" placeholder="Texto Der (VISITA)" value={rightEndzoneText} onChange={e => setRightEndzoneText(e.target.value)} />
//                                             </div>
//                                         </div>
//                                         <div className="row g-2">
//                                             <div className="col-6">
//                                                 <input type="text" className="form-control form-control-sm" placeholder="Logo Izq (vipers.png)" value={leftEndzoneLogoUrl} onChange={e => setLeftEndzoneLogoUrl(e.target.value)} />
//                                             </div>
//                                             <div className="col-6">
//                                                 <input type="text" className="form-control form-control-sm" placeholder="Logo Der (aguilas.png)" value={rightEndzoneLogoUrl} onChange={e => setRightEndzoneLogoUrl(e.target.value)} />
//                                             </div>
//                                         </div>
//                                         <div className="form-text text-muted" style={{ fontSize: '0.65rem' }}>Escribe solo el nombre del archivo. El archivo debe estar en /img/games/lineup/teams/</div>
//                                     </div>
//                                 )}

//                                 <button className="btn btn-success w-100 fw-bold shadow-sm" onClick={handleSave}>
//                                     <i className="bi bi-cloud-arrow-up-fill"></i> Guardar y Sincronizar Pantalla
//                                 </button>
//                             </div>
//                         </div>

//                         {/* PANEL DE SECUENCIA TV (RESTABLECIDO) */}
//                         <div className="card shadow-sm border-0 rounded-4 bg-light border border-warning">
//                             <div className="card-body text-center">
//                                 <h6 className="fw-bold text-warning mb-3"><i className="bi bi-camera-video-fill"></i> Máster de Transmisión</h6>
                                
//                                 <div className="d-flex gap-2 mb-3">
//                                     <button className="btn btn-outline-primary w-50 fw-bold btn-sm shadow-sm" onClick={() => toggleBoardVisibility(true)}>
//                                         <i className="bi bi-eye-fill"></i> Mostrar Pizarra
//                                     </button>
//                                     <button className="btn btn-outline-secondary w-50 fw-bold btn-sm shadow-sm" onClick={() => toggleBoardVisibility(false)}>
//                                         <i className="bi bi-eye-slash-fill"></i> Ocultar Pizarra
//                                     </button>
//                                 </div>

//                                 <div className="d-flex align-items-center justify-content-center gap-2 mb-3">
//                                     <span className="small fw-bold text-muted">Duración por jugador (s):</span>
//                                     <input type="number" className="form-control text-center w-25" value={presentationTime} onChange={(e) => setPresentationTime(e.target.value)} min="5" max="20" />
//                                 </div>
//                                 <button 
//                                     className={`btn w-100 fw-bold ${isSequenceRunning ? 'btn-danger' : 'btn-warning'}`} 
//                                     onClick={runFullSequence}
//                                     disabled={isSequenceRunning || pitchPlayers.length === 0}
//                                 >
//                                     {isSequenceRunning ? <><i className="bi bi-hourglass-split"></i> Secuencia en Curso...</> : <><i className="bi bi-play-circle-fill"></i> Lanzar Secuencia TV</>}
//                                 </button>
//                                 <button className="btn btn-outline-danger w-100 fw-bold mt-2 btn-sm" onClick={abortSequence}>
//                                     <i className="bi bi-x-circle-fill"></i> Detener y Forzar Cierre
//                                 </button>
//                             </div>
//                         </div>
//                     </div>

//                     {/* COLUMNA DERECHA: Pizarra Táctica (RESTABLECIDA) */}
//                     <div className="col-lg-8">
//                         <div className="card shadow-sm border-0 rounded-4 h-100">
//                             <div className="card-header bg-success text-white fw-bold d-flex justify-content-between align-items-center">
//                                 <span><i className={`bi ${currentMode?.iconClass || 'bi-diagram-3-fill'}`}></i> Pizarra Interactiva</span>
//                                 <span className="badge bg-dark">Ataca hacia: {teamType === 'Local' ? 'Derecha ➡' : '⬅ Izquierda'}</span>
//                             </div>
                            
//                             <div className="card-body rounded-bottom position-relative" style={{ minHeight: '550px', overflow: 'hidden', ...getPitchStyle() }}>
                                
//                                 {pitchPlayers.map((player, idx) => (
//                                     <div 
//                                         key={`${player.playerId}-${idx}`}
//                                         draggable
//                                         onDragStart={(e) => handleDragStart(e, idx)}
//                                         onDragOver={(e) => e.preventDefault()}
//                                         onDrop={(e) => handleDrop(e, idx)}
//                                         className="position-absolute d-flex flex-column align-items-center"
//                                         style={{ 
//                                             left: `${player.positionX}%`, top: `${player.positionY}%`, 
//                                             transform: 'translate(-50%, -50%)', cursor: 'grab', zIndex: 10 
//                                         }}
//                                     >
//                                         <div className="rounded-circle d-flex align-items-center justify-content-center shadow" style={{ width: '35px', height: '35px', backgroundColor: kitColor, border: '2px solid white', color: 'white', fontWeight: 'bold', fontSize: '0.9rem', position: 'relative' }}>
//                                             {player.dorsal || '#'}
//                                             {player.isCaptain && <span className="position-absolute bg-warning text-dark rounded-circle" style={{ width: '14px', height: '14px', fontSize: '0.6rem', bottom: '-2px', right: '-2px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>C</span>}
//                                         </div>
                                        
//                                         <div className="mt-1 bg-secondary rounded px-1 shadow-sm" style={{ minWidth: '100px' }}>
//                                             <select 
//                                                 className="form-select form-select-sm border-0 bg-transparent text-white text-center p-0" 
//                                                 style={{ fontSize: '0.75rem', fontWeight: 'bold', boxShadow: 'none' }}
//                                                 value={player.playerId} 
//                                                 onChange={(e) => updatePitchPlayer(idx, e.target.value)}
//                                             >
//                                                 <option value="" className="text-dark">Seleccionar...</option>
//                                                 {availablePlayers.map(ap => (
//                                                     <option key={ap.id} value={ap.id} className="text-dark">{ap.dorsal} - {ap.name}</option>
//                                                 ))}
//                                             </select>
//                                         </div>
                                        
//                                         <div className="d-flex gap-1 mt-1 opacity-75">
//                                             <button className="btn btn-sm btn-dark border-secondary p-0 px-1" style={{ fontSize: '0.6rem' }} onClick={() => setCaptain(idx)} title="Hacer Capitán">©</button>
//                                             <button className="btn btn-sm btn-info p-0 px-1" style={{ fontSize: '0.6rem' }} onClick={() => firePresentation('show_player', player.playerId)} disabled={!player.playerId} title="Presentar en Pantalla"><i className="bi bi-play-fill text-white"></i></button>
//                                         </div>
//                                     </div>
//                                 ))}

//                                 <div className="position-absolute bottom-0 start-0 p-3">
//                                     <button className="btn btn-sm btn-dark border-light d-flex align-items-center gap-2 shadow" onClick={() => firePresentation('show_dt')}>
//                                         <div className="rounded-circle bg-secondary d-flex align-items-center justify-content-center text-white" style={{ width: '25px', height: '25px', fontSize: '0.7rem' }}>
//                                             {gameMode === 'basketball' ? 'HC' : 'DT'}
//                                         </div>
//                                         Presentar: {managerName}
//                                     </button>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </SecondaryBase>
//     );
// };

// export { Lineup };









// import React, { useEffect, useState, useRef } from 'react';
// import { SecondaryBase } from '../Commons/SecondaryBase';
// import { useFloatMessage, MESSAGE_TYPE } from '../../Providers/FloatMessage';

// // Importamos la Lógica de Negocio
// import { GetLineup, SaveLineup, TriggerPresentation } from '../../../utilities/BL/Lineup';
// import { GetTeams, GetPlayersByTeam } from '../../../utilities/BL/SportPlayer';

// // --- CONFIGURACIÓN MULTIDEPORTE ---
// // const SPORT_MODES = {
// //     'soccer': { name: 'Fútbol 11', maxPlayers: 11, defaultFormation: '4-4-2', icon: 'bi-record-circle' },
// //     'basketball': { name: 'Básquetbol (5v5)', maxPlayers: 5, defaultFormation: '4-Out 1-In', icon: 'bi-dribbble' },
// //     'flag_football': { name: 'Tocho Bandera (5v5)', maxPlayers: 5, defaultFormation: 'ofensiva-abierta', icon: 'bi-vinyl-fill' }
// // };

// // // --- DICCIONARIO MAESTRO DE FORMACIONES ---
// // const FORMATIONS = {
// //     'soccer': {
// //         '4-4-2': [{l:5, t:50}, {l:22, t:90}, {l:22, t:10}, {l:18, t:65}, {l:18, t:35}, {l:50, t:90}, {l:50, t:10}, {l:45, t:65}, {l:45, t:35}, {l:75, t:60}, {l:75, t:40}],
// //         '4-2-3-1': [{l:5, t:50}, {l:22, t:90}, {l:22, t:10}, {l:18, t:65}, {l:18, t:35}, {l:40, t:65}, {l:40, t:35}, {l:60, t:90}, {l:60, t:10}, {l:60, t:50}, {l:80, t:50}],
// //         '4-3-3': [{l:5, t:50}, {l:22, t:90}, {l:22, t:10}, {l:18, t:65}, {l:18, t:35}, {l:40, t:50}, {l:50, t:80}, {l:50, t:20}, {l:80, t:50}, {l:75, t:90}, {l:75, t:10}],
// //         '3-5-2': [{l:5, t:50}, {l:18, t:50}, {l:18, t:80}, {l:18, t:20}, {l:35, t:50}, {l:45, t:90}, {l:45, t:10}, {l:55, t:70}, {l:55, t:30}, {l:75, t:55}, {l:75, t:45}],
// //         '5-3-2': [{l:5, t:50}, {l:20, t:50}, {l:20, t:70}, {l:20, t:30}, {l:25, t:90}, {l:25, t:10}, {l:45, t:50}, {l:50, t:75}, {l:50, t:25}, {l:75, t:60}, {l:75, t:40}],
// //         '5-4-1': [{l:5, t:50}, {l:20, t:50}, {l:20, t:70}, {l:20, t:30}, {l:25, t:90}, {l:25, t:10}, {l:45, t:70}, {l:45, t:30}, {l:50, t:90}, {l:50, t:10}, {l:75, t:50}]
// //     },
// //     'basketball': {
// //         'Man-to-Man': [{l:32, t:50}, {l:22, t:25}, {l:22, t:75}, {l:10, t:35}, {l:10, t:65}],
// //         '2-3 Zone': [{l:26, t:35}, {l:26, t:65}, {l:12, t:15}, {l:12, t:85}, {l:8, t:50}],
// //         '3-2 Zone': [{l:28, t:50}, {l:22, t:25}, {l:22, t:75}, {l:10, t:35}, {l:10, t:65}],
// //         '4-Out 1-In': [{l:38, t:35}, {l:38, t:65}, {l:15, t:10}, {l:15, t:90}, {l:12, t:50}],
// //         '5-Out': [{l:42, t:50}, {l:32, t:18}, {l:32, t:82}, {l:10, t:10}, {l:10, t:90}]
// //     },
// //     'flag_football': {
// //         'ofensiva-abierta': [{l: 25, t: 50}, {l: 40, t: 50}, {l: 40, t: 20}, {l: 40, t: 80}, {l: 40, t: 35}],
// //         'ofensiva-gemelos': [{l: 25, t: 50}, {l: 40, t: 50}, {l: 40, t: 20}, {l: 40, t: 70}, {l: 40, t: 85}],
// //         'defensiva-zona': [{l: 60, t: 50}, {l: 55, t: 30}, {l: 55, t: 70}, {l: 75, t: 35}, {l: 75, t: 65}],
// //         'defensiva-hombre': [{l: 60, t: 50}, {l: 55, t: 20}, {l: 55, t: 80}, {l: 55, t: 35}, {l: 80, t: 50}]
// //     }
// // };

// const Lineup = ({ getOutOfTheDynamic }) => {
//     const { showMessage } = useFloatMessage();

//     // --- ESTADOS DE CONFIGURACIÓN ---
//     const [sportConfig, setSportConfig] = useState(null); 
//     const [teamType, setTeamType] = useState('Local'); 
//     const [gameMode, setGameMode] = useState('soccer'); 
//     const [teams, setTeams] = useState([]);
//     const [availablePlayers, setAvailablePlayers] = useState([]);
    
//     // --- ESTADO TÁCTICO ---
//     const [teamId, setTeamId] = useState('');
//     const [formation, setFormation] = useState(SPORT_MODES['soccer'].defaultFormation);
//     const [kitColor, setKitColor] = useState('#1e293b');
//     const [managerName, setManagerName] = useState('Director Técnico');
//     const [pitchPlayers, setPitchPlayers] = useState([]);

//     // --- ESTADO DE SECUENCIA TV ---
//     const [isSequenceRunning, setIsSequenceRunning] = useState(false);
//     const [presentationTime, setPresentationTime] = useState(8); 
//     const sequenceRunningRef = useRef(false);

//     // --- ESTADOS EXCLUSIVOS: ZONAS DE ANOTACIÓN (TOCHO/AMERICANO) ---
//     // const [leftEndzoneText, setLeftEndzoneText] = useState('LOCAL');
//     // const [rightEndzoneText, setRightEndzoneText] = useState('VISITA');
//     // const [leftEndzoneLogoUrl, setLeftEndzoneLogoUrl] = useState('');
//     // const [rightEndzoneLogoUrl, setRightEndzoneLogoUrl] = useState('');


//     useEffect(() => {
//         loadInitialData();
//     }, []);

//     const loadInitialData = async () => {
//         try {
//             // 1.- Cargamos los deportes y formaciones desde tu nuevo endpoint
//             const res = await fetch('/api/v1/sports/modes'); 
//             const data = await res.json();
//             setSportConfig(data); // Aquí guardas toda la estructura dinámica
            
//             // 2.- Una vez cargada la config, cargamos lo demás
//             loadTeams();
//             // 3.- Usamos 'soccer' como default inicial si no hay config aún
//             fetchLineup(teamType, 'soccer');
//         } catch (err) {
//             showMessage("Error cargando configuración deportiva", MESSAGE_TYPE.BAD);
//         }
//     };

//     // useEffect(() => {
//     //     loadTeams();
//     //     fetchLineup(teamType);
//     // // eslint-disable-next-line react-hooks/exhaustive-deps
//     // }, [teamType]);

//     // const loadTeams = async () => {
//     //     const res = await GetTeams();
//     //     if (res.success) setTeams(res.data);
//     // };

//     // const fetchLineup = async (type) => {
//     //     const res = await GetLineup(type);
//     //     if (res.success && res.data && res.data.teamId) {
//     //         const data = res.data;
//     //         const fetchedMode = data.gameMode || 'soccer';
            
//     //         setGameMode(fetchedMode);
//     //         setTeamId(data.teamId);
//     //         setFormation(data.formation || SPORT_MODES[fetchedMode].defaultFormation);
//     //         setKitColor(data.kitColor || '#1e293b');
//     //         setManagerName(data.managerName || 'Director Técnico');
            
//     //         setLeftEndzoneText(data.leftEndzoneText || 'LOCAL');
//     //         setRightEndzoneText(data.rightEndzoneText || 'VISITA');
//     //         setLeftEndzoneLogoUrl(data.leftEndzoneLogoUrl || '');
//     //         setRightEndzoneLogoUrl(data.rightEndzoneLogoUrl || '');
            
//     //         await loadTeamRoster(data.teamId);
//     //         setPitchPlayers(data.players || []);
//     //     } else {
//     //         resetBoardState();
//     //     }
//     // };

//     const loadTeams = async () => {
//         const res = await GetTeams();
//         if (res.success) setTeams(res.data);
//     };

//     const fetchLineup = async (type, mode = gameMode) => {
//         const res = await GetLineup(type);
//         if (res.success && res.data && res.data.teamId) {
//             const data = res.data;
//             setGameMode(data.gameMode || 'soccer');
//             setTeamId(data.teamId);
//             setFormation(data.formation);
//             setKitColor(data.kitColor);
//             setManagerName(data.managerName);
//             setLeftEndzoneText(data.leftEndzoneText);
//             setRightEndzoneText(data.rightEndzoneText);
//             setLeftEndzoneLogoUrl(data.leftEndzoneLogoUrl);
//             setRightEndzoneLogoUrl(data.rightEndzoneLogoUrl);
            
//             await loadTeamRoster(data.teamId);
//             setPitchPlayers(data.players || []);
//         } else {
//             resetBoardState(mode);
//         }
//     };

//     // --- LÓGICA DE APOYO ---
//     const resetBoardState = (mode) => {
//         if (!sportConfig) return;
//         const modeData = sportConfig.find(m => m.code === mode);
//         setTeamId('');
//         setFormation(Object.keys(modeData.formations)[0]);
//         setKitColor('#1e293b');
//         setManagerName('Director Técnico');
//         setPitchPlayers([]);
//         setAvailablePlayers([]);
//     };

//     const applyFormationTemplate = (formName, currentMode = gameMode) => {
//         if (!sportConfig) return;
//         setFormation(formName);
//         const modeData = sportConfig.find(m => m.code === currentMode);
//         const coords = modeData.formations[formName];
        
//         if (!coords) return;

//         const newPitch = coords.map((c, index) => {
//             const existingPlayer = pitchPlayers[index];
//             return {
//                 playerId: existingPlayer ? existingPlayer.playerId : '',
//                 name: existingPlayer ? existingPlayer.name : 'VACÍO',
//                 dorsal: existingPlayer ? existingPlayer.dorsal : 0,
//                 isCaptain: existingPlayer ? existingPlayer.isCaptain : false,
//                 positionX: teamType === 'Local' ? c.l : 100 - c.l, 
//                 positionY: c.t
//             };
//         });
//         setPitchPlayers(newPitch);
//     };

//     // const loadTeamRoster = async (id) => {
//     //     if (!id) return;
//     //     const res = await GetPlayersByTeam(id);
//     //     if (res.success) setAvailablePlayers(res.data);
//     // };

//     // const resetBoardState = (mode = gameMode) => {
//     //     setTeamId('');
//     //     setFormation(SPORT_MODES[mode].defaultFormation);
//     //     setKitColor('#1e293b');
//     //     setManagerName('Director Técnico');
//     //     setPitchPlayers([]);
//     //     setAvailablePlayers([]);
        
//     //     setLeftEndzoneText('LOCAL');
//     //     setRightEndzoneText('VISITA');
//     //     setLeftEndzoneLogoUrl('');
//     //     setRightEndzoneLogoUrl('');
//     // };

//     const handleTeamChange = async (newTeamId) => {
//         // CORRECCIÓN 1: Si es el mismo equipo, no borramos a los jugadores accidentalmente
//         if (newTeamId === teamId) return;

//         setManagerName('Director Técnico'); 
//         setPitchPlayers([]);
//         setTeamId(newTeamId);
        
//         if (newTeamId) {
//             await loadTeamRoster(newTeamId);
//             applyFormationTemplate(formation, gameMode);
//         }
//     };

//     // const handleGameModeChange = (newMode) => {
//     //     if (pitchPlayers.length > 0) {
//     //         if (!window.confirm("Cambiar de deporte reiniciará las posiciones en la pizarra. ¿Deseas continuar?")) {
//     //             return;
//     //         }
//     //     }
//     //     setGameMode(newMode);
//     //     resetBoardState(newMode);
//     //     applyFormationTemplate(SPORT_MODES[newMode].defaultFormation, newMode);
//     // };

//     const handleGameModeChange = (newMode) => {
//         if (pitchPlayers.length > 0) {
//             if (!window.confirm("Cambiar de deporte reiniciará las posiciones en la pizarra. ¿Deseas continuar?")) {
//                 return;
//             }
//         }
        
//         setGameMode(newMode);
        
//         // Buscamos la configuración del nuevo modo en el estado dinámico
//         const modeData = sportConfig.find(m => m.code === newMode);
        
//         // Obtenemos la primera formación disponible como default
//         const firstFormation = Object.keys(modeData.formations)[0];
        
//         resetBoardState(newMode);
//         applyFormationTemplate(firstFormation, newMode);
//     };

//     // const applyFormationTemplate = (formName, currentMode = gameMode) => {
//     //     setFormation(formName);
//     //     const coords = FORMATIONS[currentMode][formName];
//     //     if (!coords) return;

//     //     const newPitch = coords.map((c, index) => {
//     //         const existingPlayer = pitchPlayers[index];
//     //         return {
//     //             playerId: existingPlayer ? existingPlayer.playerId : '',
//     //             name: existingPlayer ? existingPlayer.name : 'VACÍO',
//     //             dorsal: existingPlayer ? existingPlayer.dorsal : 0,
//     //             isCaptain: existingPlayer ? existingPlayer.isCaptain : false,
//     //             positionX: teamType === 'Local' ? c.l : 100 - c.l, 
//     //             positionY: c.t
//     //         };
//     //     });
//     //     setPitchPlayers(newPitch);
//     // };

//     // const applyFormationTemplate = (formName, currentMode = gameMode) => {
//     //     setFormation(formName);
        
//     //     // Buscamos las coordenadas en el objeto dinámico
//     //     const modeData = sportConfig.find(m => m.code === currentMode);
//     //     const coords = modeData.formations[formName]; // Aquí accedes a la lista de coordenadas
        
//     //     if (!coords) return;

//     //     const newPitch = coords.map((c, index) => {
//     //         const existingPlayer = pitchPlayers[index];
//     //         return {
//     //             playerId: existingPlayer ? existingPlayer.playerId : '',
//     //             name: existingPlayer ? existingPlayer.name : 'VACÍO',
//     //             dorsal: existingPlayer ? existingPlayer.dorsal : 0,
//     //             isCaptain: existingPlayer ? existingPlayer.isCaptain : false,
//     //             // c.l y c.t son las propiedades l y t que guardaste en el objeto
//     //             positionX: teamType === 'Local' ? c.l : 100 - c.l, 
//     //             positionY: c.t
//     //         };
//     //     });
//     //     setPitchPlayers(newPitch);
//     // };

//     const updatePitchPlayer = (index, playerId) => {
//         const playerObj = availablePlayers.find(p => p.id === parseInt(playerId));
//         if (!playerObj) return;

//         const newPitch = [...pitchPlayers];
//         newPitch[index] = {
//             ...newPitch[index],
//             playerId: playerObj.id,
//             name: playerObj.name,
//             dorsal: playerObj.dorsal
//         };
//         setPitchPlayers(newPitch);
//     };

//     const setCaptain = (index) => {
//         const newPitch = pitchPlayers.map((p, i) => ({ ...p, isCaptain: i === index }));
//         setPitchPlayers(newPitch);
//     };

//     const handleDragStart = (e, index) => { e.dataTransfer.setData('sourceIndex', index); };

//     const handleDrop = (e, targetIndex) => {
//         const sourceIndex = parseInt(e.dataTransfer.getData('sourceIndex'));
//         if (sourceIndex === targetIndex || isNaN(sourceIndex)) return;

//         const newPitch = [...pitchPlayers];
//         const tempPlayer = { ...newPitch[sourceIndex] };
        
//         newPitch[sourceIndex].playerId = newPitch[targetIndex].playerId;
//         newPitch[sourceIndex].name = newPitch[targetIndex].name;
//         newPitch[sourceIndex].dorsal = newPitch[targetIndex].dorsal;
//         newPitch[sourceIndex].isCaptain = newPitch[targetIndex].isCaptain;

//         newPitch[targetIndex].playerId = tempPlayer.playerId;
//         newPitch[targetIndex].name = tempPlayer.name;
//         newPitch[targetIndex].dorsal = tempPlayer.dorsal;
//         newPitch[targetIndex].isCaptain = tempPlayer.isCaptain;

//         setPitchPlayers(newPitch);
//     };

//     const handleSave = async () => {
//         if (pitchPlayers.some(p => !p.playerId)) {
//             showMessage(`Faltan asignar jugadores a las ${SPORT_MODES[gameMode].maxPlayers} posiciones.`, MESSAGE_TYPE.WARNING);
//             return;
//         }

//         const payload = {
//             teamType,
//             teamId: parseInt(teamId),
//             gameMode,
//             formation,
//             kitColor,
//             managerName,
//             leftEndzoneText,
//             rightEndzoneText,
//             leftEndzoneLogoUrl,
//             rightEndzoneLogoUrl,
//             players: pitchPlayers.map(p => ({
//                 playerId: p.playerId,
//                 isCaptain: p.isCaptain,
//                 positionX: p.positionX,
//                 positionY: p.positionY
//             }))
//         };

//         const res = await SaveLineup(payload);
//         if (res.success) {
//             showMessage("Alineación guardada y sincronizada", MESSAGE_TYPE.SUCCESS);
//         } else {
//             showMessage(res.message, MESSAGE_TYPE.BAD);
//         }
//     };

//     const firePresentation = async (action, playerId = null) => {
//         await TriggerPresentation(action, playerId);
//         if(action !== 'close' && action !== 'hide_board' && action !== 'show_board') {
//             showMessage(`Presentando en pantalla...`, MESSAGE_TYPE.SUCCESS);
//         }
//     };

//     // BOTONES DE VISIBILIDAD
//     const toggleBoardVisibility = async (show) => {
//         await TriggerPresentation(show ? 'show_board' : 'hide_board');
//         showMessage(show ? "Pizarra VISIBLE en transmisión" : "Pizarra OCULTA en transmisión", MESSAGE_TYPE.SUCCESS);
//     };

//     const runFullSequence = async () => {
//         if (sequenceRunningRef.current) return;
        
//         sequenceRunningRef.current = true;
//         setIsSequenceRunning(true);
//         showMessage("Secuencia Automática Iniciada", MESSAGE_TYPE.SUCCESS);

//         const sortedPlayers = [...pitchPlayers].sort((a, b) => a.positionX - b.positionX);

//         for (let player of sortedPlayers) {
//             if (!sequenceRunningRef.current) break; 
//             if (!player.playerId) continue;
            
//             await TriggerPresentation('show_player', player.playerId);
            
//             for(let i = 0; i < presentationTime; i++) {
//                 if (!sequenceRunningRef.current) break;
//                 await new Promise(resolve => setTimeout(resolve, 1000));
//             }
//         }

//         if (sequenceRunningRef.current) {
//             await TriggerPresentation('show_dt', null);
//             for(let i = 0; i < presentationTime; i++) {
//                 if (!sequenceRunningRef.current) break;
//                 await new Promise(resolve => setTimeout(resolve, 1000));
//             }
//         }

//         if (sequenceRunningRef.current) {
//             await TriggerPresentation('close', null);
//             showMessage("Secuencia Finalizada", MESSAGE_TYPE.SUCCESS);
//         }

//         sequenceRunningRef.current = false;
//         setIsSequenceRunning(false);
//     };

//     const abortSequence = async () => {
//         sequenceRunningRef.current = false; 
//         setIsSequenceRunning(false);
//         await TriggerPresentation('close', null);
//         showMessage("Presentación abortada", MESSAGE_TYPE.WARNING);
//     };

//     const getPitchStyle = () => {
//         if(gameMode === 'basketball') return { backgroundColor: '#d68743', border: '2px solid white' };
//         if(gameMode === 'flag_football') return { backgroundColor: '#2e5932', border: '2px dashed yellow' };
//         return { backgroundColor: '#1a4d2e', border: '2px solid rgba(255,255,255,0.5)' };
//     };

//     return (
//         <SecondaryBase actionToExecute={getOutOfTheDynamic}>
//             <div className="container-fluid pb-5">
//                 <div className="text-center mb-4">
//                     <h3 className="fw-bold"><i className="bi bi-diagram-3-fill"></i> Súper Lienzo: Alineación Multideporte</h3>
//                     <p className="text-muted small">Configura la táctica y lanza la presentación estelar a la transmisión.</p>
//                 </div>

//                 <div className="row g-4">
//                     {/* COLUMNA IZQUIERDA: Configuración */}
//                     <div className="col-lg-4">
//                         <div className="card shadow-sm border-0 rounded-4 mb-4">
//                             <div className="card-header bg-dark text-white fw-bold d-flex justify-content-between align-items-center">
//                                 <span><i className="bi bi-gear-fill"></i> Configuración</span>
//                                 <span className="badge bg-primary">{SPORT_MODES[gameMode].name}</span>
//                             </div>
//                             <div className="card-body">
                                
//                                 <div className="mb-3 bg-light p-2 rounded border border-info">
//                                     <label className="form-label small fw-bold text-info-emphasis">Modalidad Deportiva</label>
//                                     {/* <select className="form-select border-info" value={gameMode} onChange={(e) => handleGameModeChange(e.target.value)}>
//                                         {Object.keys(SPORT_MODES).map(key => (
//                                             <option key={key} value={key}>{SPORT_MODES[key].name}</option>
//                                         ))}
//                                     </select> */}
//                                     <select className="form-select border-info" value={gameMode} onChange={(e) => handleGameModeChange(e.target.value)}>
//                                         {sportConfig && sportConfig.map(mode => (
//                                             <option key={mode.code} value={mode.code}>{mode.name}</option>
//                                         ))}
//                                     </select>
//                                 </div>

//                                 <div className="mb-3">
//                                     <label className="form-label small fw-bold">Tipo de Equipo</label>
//                                     <select className="form-select" value={teamType} onChange={(e) => setTeamType(e.target.value)}>
//                                         <option value="Local">Local</option>
//                                         <option value="Away">Visitante</option>
//                                     </select>
//                                 </div>
//                                 <div className="mb-3">
//                                     <label className="form-label small fw-bold">Seleccionar Equipo de BD</label>
//                                     <select className="form-select" value={teamId} onChange={(e) => handleTeamChange(e.target.value)}>
//                                         <option value="">-- Elige un equipo --</option>
//                                         {teams.map(t => <option key={t.id} value={t.id}>{t.name}</option>)}
//                                     </select>
//                                 </div>
//                                 <div className="mb-3">
//                                     <label className="form-label small fw-bold">Formación ({SPORT_MODES[gameMode].maxPlayers} Jugadores)</label>
//                                     {/* <select className="form-select" value={formation} onChange={(e) => applyFormationTemplate(e.target.value)}>
//                                         {Object.keys(FORMATIONS[gameMode]).map(f => <option key={f} value={f}>{f}</option>)}
//                                     </select> */}
//                                     <select className="form-select" value={formation} onChange={(e) => applyFormationTemplate(e.target.value)}>
//                                         {sportConfig && sportConfig.find(m => m.code === gameMode)?.formations 
//                                             ? Object.keys(sportConfig.find(m => m.code === gameMode).formations).map(f => (
//                                                 <option key={f} value={f}>{f}</option>
//                                             ))
//                                             : <option>Cargando...</option>
//                                         }
//                                     </select>
//                                 </div>
//                                 <div className="row g-2 mb-3">
//                                     <div className="col-6">
//                                         <label className="form-label small fw-bold">Color Uniforme</label>
//                                         <input type="color" className="form-control form-control-color w-100" value={kitColor} onChange={(e) => setKitColor(e.target.value)} />
//                                     </div>
//                                     <div className="col-6">
//                                         <label className="form-label small fw-bold">Nombre del DT</label>
//                                         <input type="text" className="form-control" value={managerName} onChange={(e) => setManagerName(e.target.value)} placeholder="Ej. Guardiola" />
//                                     </div>
//                                 </div>

//                                 {gameMode === 'flag_football' && (
//                                     <div className="border border-success rounded p-2 mb-3 bg-light">
//                                         <label className="form-label small fw-bold text-success mb-2"><i className="bi bi-flag-fill"></i> Zonas de Anotación (Endzones)</label>
//                                         <div className="row g-2 mb-2">
//                                             <div className="col-6">
//                                                 <input type="text" className="form-control form-control-sm" placeholder="Texto Izq (LOCAL)" value={leftEndzoneText} onChange={e => setLeftEndzoneText(e.target.value)} />
//                                             </div>
//                                             <div className="col-6">
//                                                 <input type="text" className="form-control form-control-sm" placeholder="Texto Der (VISITA)" value={rightEndzoneText} onChange={e => setRightEndzoneText(e.target.value)} />
//                                             </div>
//                                         </div>
//                                         <div className="row g-2">
//                                             <div className="col-6">
//                                                 <input type="text" className="form-control form-control-sm" placeholder="Logo Izq (vipers.png)" value={leftEndzoneLogoUrl} onChange={e => setLeftEndzoneLogoUrl(e.target.value)} />
//                                             </div>
//                                             <div className="col-6">
//                                                 <input type="text" className="form-control form-control-sm" placeholder="Logo Der (aguilas.png)" value={rightEndzoneLogoUrl} onChange={e => setRightEndzoneLogoUrl(e.target.value)} />
//                                             </div>
//                                         </div>
//                                         <div className="form-text text-muted" style={{ fontSize: '0.65rem' }}>Escribe solo el nombre del archivo. El archivo debe estar en /img/games/lineup/teams/</div>
//                                     </div>
//                                 )}

//                                 <button className="btn btn-success w-100 fw-bold shadow-sm" onClick={handleSave}>
//                                     <i className="bi bi-cloud-arrow-up-fill"></i> Guardar y Sincronizar Pantalla
//                                 </button>
//                             </div>
//                         </div>

//                         {/* PANEL DE SECUENCIA TV */}
//                         <div className="card shadow-sm border-0 rounded-4 bg-light border border-warning">
//                             <div className="card-body text-center">
//                                 <h6 className="fw-bold text-warning mb-3"><i className="bi bi-camera-video-fill"></i> Máster de Transmisión</h6>
                                
//                                 {/* NUEVOS BOTONES DE VISIBILIDAD */}
//                                 <div className="d-flex gap-2 mb-3">
//                                     <button className="btn btn-outline-primary w-50 fw-bold btn-sm shadow-sm" onClick={() => toggleBoardVisibility(true)}>
//                                         <i className="bi bi-eye-fill"></i> Mostrar Pizarra
//                                     </button>
//                                     <button className="btn btn-outline-secondary w-50 fw-bold btn-sm shadow-sm" onClick={() => toggleBoardVisibility(false)}>
//                                         <i className="bi bi-eye-slash-fill"></i> Ocultar Pizarra
//                                     </button>
//                                 </div>

//                                 <div className="d-flex align-items-center justify-content-center gap-2 mb-3">
//                                     <span className="small fw-bold text-muted">Duración por jugador (s):</span>
//                                     <input type="number" className="form-control text-center w-25" value={presentationTime} onChange={(e) => setPresentationTime(e.target.value)} min="5" max="20" />
//                                 </div>
//                                 <button 
//                                     className={`btn w-100 fw-bold ${isSequenceRunning ? 'btn-danger' : 'btn-warning'}`} 
//                                     onClick={runFullSequence}
//                                     disabled={isSequenceRunning || pitchPlayers.length === 0}
//                                 >
//                                     {isSequenceRunning ? <><i className="bi bi-hourglass-split"></i> Secuencia en Curso...</> : <><i className="bi bi-play-circle-fill"></i> Lanzar Secuencia TV</>}
//                                 </button>
//                                 <button className="btn btn-outline-danger w-100 fw-bold mt-2 btn-sm" onClick={abortSequence}>
//                                     <i className="bi bi-x-circle-fill"></i> Detener y Forzar Cierre
//                                 </button>
//                             </div>
//                         </div>
//                     </div>

//                     {/* COLUMNA DERECHA: Pizarra Táctica */}
//                     <div className="col-lg-8">
//                         <div className="card shadow-sm border-0 rounded-4 h-100">
//                             <div className="card-header bg-success text-white fw-bold d-flex justify-content-between align-items-center">
//                                 <span><i className={`bi ${SPORT_MODES[gameMode].icon}`}></i> Pizarra Interactiva</span>
//                                 <span className="badge bg-dark">Ataca hacia: {teamType === 'Local' ? 'Derecha ➡' : '⬅ Izquierda'}</span>
//                             </div>
                            
//                             <div className="card-body rounded-bottom position-relative" style={{ minHeight: '550px', overflow: 'hidden', ...getPitchStyle() }}>
                                
//                                 {pitchPlayers.map((player, idx) => (
//                                     <div 
//                                         key={`${player.playerId}-${idx}`}
//                                         draggable
//                                         onDragStart={(e) => handleDragStart(e, idx)}
//                                         onDragOver={(e) => e.preventDefault()}
//                                         onDrop={(e) => handleDrop(e, idx)}
//                                         className="position-absolute d-flex flex-column align-items-center"
//                                         style={{ 
//                                             left: `${player.positionX}%`, top: `${player.positionY}%`, 
//                                             transform: 'translate(-50%, -50%)', cursor: 'grab', zIndex: 10 
//                                         }}
//                                     >
//                                         <div className="rounded-circle d-flex align-items-center justify-content-center shadow" style={{ width: '35px', height: '35px', backgroundColor: kitColor, border: '2px solid white', color: 'white', fontWeight: 'bold', fontSize: '0.9rem', position: 'relative' }}>
//                                             {player.dorsal || '#'}
//                                             {player.isCaptain && <span className="position-absolute bg-warning text-dark rounded-circle" style={{ width: '14px', height: '14px', fontSize: '0.6rem', bottom: '-2px', right: '-2px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>C</span>}
//                                         </div>
                                        
//                                         <div className="mt-1 bg-secondary rounded px-1 shadow-sm" style={{ minWidth: '100px' }}>
//                                             <select 
//                                                 className="form-select form-select-sm border-0 bg-transparent text-white text-center p-0" 
//                                                 style={{ fontSize: '0.75rem', fontWeight: 'bold', boxShadow: 'none' }}
//                                                 value={player.playerId} 
//                                                 onChange={(e) => updatePitchPlayer(idx, e.target.value)}
//                                             >
//                                                 <option value="" className="text-dark">Seleccionar...</option>
//                                                 {availablePlayers.map(ap => (
//                                                     <option key={ap.id} value={ap.id} className="text-dark">{ap.dorsal} - {ap.name}</option>
//                                                 ))}
//                                             </select>
//                                         </div>
                                        
//                                         <div className="d-flex gap-1 mt-1 opacity-75">
//                                             <button className="btn btn-sm btn-dark border-secondary p-0 px-1" style={{ fontSize: '0.6rem' }} onClick={() => setCaptain(idx)} title="Hacer Capitán">©</button>
//                                             <button className="btn btn-sm btn-info p-0 px-1" style={{ fontSize: '0.6rem' }} onClick={() => firePresentation('show_player', player.playerId)} disabled={!player.playerId} title="Presentar en Pantalla"><i className="bi bi-play-fill text-white"></i></button>
//                                         </div>
//                                     </div>
//                                 ))}

//                                 <div className="position-absolute bottom-0 start-0 p-3">
//                                     <button className="btn btn-sm btn-dark border-light d-flex align-items-center gap-2 shadow" onClick={() => firePresentation('show_dt')}>
//                                         <div className="rounded-circle bg-secondary d-flex align-items-center justify-content-center text-white" style={{ width: '25px', height: '25px', fontSize: '0.7rem' }}>
//                                             {gameMode === 'basketball' ? 'HC' : 'DT'}
//                                         </div>
//                                         Presentar: {managerName}
//                                     </button>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </SecondaryBase>
//     );
// };

// export { Lineup };









import React, { useEffect, useState, useRef } from 'react';
import { SecondaryBase } from '../Commons/SecondaryBase';
import { useFloatMessage, MESSAGE_TYPE } from '../../Providers/FloatMessage';

// Importamos la Lógica de Negocio
import { GetLineup, SaveLineup, TriggerPresentation } from '../../../utilities/BL/Lineup';
import { GetTeams, GetPlayersByTeam } from '../../../utilities/BL/SportPlayer';

// --- CONFIGURACIÓN MULTIDEPORTE ---
const SPORT_MODES = {
    'soccer': { name: 'Fútbol 11', maxPlayers: 11, defaultFormation: '4-4-2', icon: 'bi-record-circle' },
    'soccer_7': { name: 'Fútbol 7', maxPlayers: 7, defaultFormation: '2-3-1', icon: 'bi-record-circle-fill' },
    'basketball': { name: 'Básquetbol (5v5)', maxPlayers: 5, defaultFormation: '4-Out 1-In', icon: 'bi-dribbble' },
    'flag_football': { name: 'Tocho Bandera (5v5)', maxPlayers: 5, defaultFormation: 'ofensiva-abierta', icon: 'bi-vinyl-fill' }
};

// --- DICCIONARIO MAESTRO DE FORMACIONES ---
const FORMATIONS = {
    'soccer': {
        '4-4-2': [{l:5, t:50}, {l:22, t:90}, {l:22, t:10}, {l:18, t:65}, {l:18, t:35}, {l:50, t:90}, {l:50, t:10}, {l:45, t:65}, {l:45, t:35}, {l:75, t:60}, {l:75, t:40}],
        '4-2-3-1': [{l:5, t:50}, {l:22, t:90}, {l:22, t:10}, {l:18, t:65}, {l:18, t:35}, {l:40, t:65}, {l:40, t:35}, {l:60, t:90}, {l:60, t:10}, {l:60, t:50}, {l:80, t:50}],
        '4-3-3': [{l:5, t:50}, {l:22, t:90}, {l:22, t:10}, {l:18, t:65}, {l:18, t:35}, {l:40, t:50}, {l:50, t:80}, {l:50, t:20}, {l:80, t:50}, {l:75, t:90}, {l:75, t:10}],
        '3-5-2': [{l:5, t:50}, {l:18, t:50}, {l:18, t:80}, {l:18, t:20}, {l:35, t:50}, {l:45, t:90}, {l:45, t:10}, {l:55, t:70}, {l:55, t:30}, {l:75, t:55}, {l:75, t:45}],
        '5-3-2': [{l:5, t:50}, {l:20, t:50}, {l:20, t:70}, {l:20, t:30}, {l:25, t:90}, {l:25, t:10}, {l:45, t:50}, {l:50, t:75}, {l:50, t:25}, {l:75, t:60}, {l:75, t:40}],
        '5-4-1': [{l:5, t:50}, {l:20, t:50}, {l:20, t:70}, {l:20, t:30}, {l:25, t:90}, {l:25, t:10}, {l:45, t:70}, {l:45, t:30}, {l:50, t:90}, {l:50, t:10}, {l:75, t:50}]
    },
    'soccer_7': {
        '2-3-1': [{l:5, t:50}, {l:22, t:75}, {l:22, t:25}, {l:50, t:50}, {l:45, t:85}, {l:45, t:15}, {l:75, t:50}],
        '3-2-1': [{l:5, t:50}, {l:22, t:50}, {l:22, t:80}, {l:22, t:20}, {l:50, t:65}, {l:50, t:35}, {l:75, t:50}],
        '2-2-2': [{l:5, t:50}, {l:22, t:75}, {l:22, t:25}, {l:48, t:75}, {l:48, t:25}, {l:75, t:65}, {l:75, t:35}]
    },
    'basketball': {
        'Man-to-Man': [{l:32, t:50}, {l:22, t:25}, {l:22, t:75}, {l:10, t:35}, {l:10, t:65}],
        '2-3 Zone': [{l:26, t:35}, {l:26, t:65}, {l:12, t:15}, {l:12, t:85}, {l:8, t:50}],
        '3-2 Zone': [{l:28, t:50}, {l:22, t:25}, {l:22, t:75}, {l:10, t:35}, {l:10, t:65}],
        '4-Out 1-In': [{l:38, t:35}, {l:38, t:65}, {l:15, t:10}, {l:15, t:90}, {l:12, t:50}],
        '5-Out': [{l:42, t:50}, {l:32, t:18}, {l:32, t:82}, {l:10, t:10}, {l:10, t:90}]
    },
    'flag_football': {
        'ofensiva-abierta': [{l: 25, t: 50}, {l: 40, t: 50}, {l: 40, t: 20}, {l: 40, t: 80}, {l: 40, t: 35}],
        'ofensiva-gemelos': [{l: 25, t: 50}, {l: 40, t: 50}, {l: 40, t: 20}, {l: 40, t: 70}, {l: 40, t: 85}],
        'defensiva-zona': [{l: 60, t: 50}, {l: 55, t: 30}, {l: 55, t: 70}, {l: 75, t: 35}, {l: 75, t: 65}],
        'defensiva-hombre': [{l: 60, t: 50}, {l: 55, t: 20}, {l: 55, t: 80}, {l: 55, t: 35}, {l: 80, t: 50}]
    }
};

const Lineup = ({ getOutOfTheDynamic }) => {
    const { showMessage } = useFloatMessage();

    // --- ESTADOS DE CONFIGURACIÓN ---
    const [teamType, setTeamType] = useState('Local'); 
    const [gameMode, setGameMode] = useState('soccer'); 
    const [teams, setTeams] = useState([]);
    const [availablePlayers, setAvailablePlayers] = useState([]);
    
    // --- ESTADO TÁCTICO ---
    const [teamId, setTeamId] = useState('');
    const [formation, setFormation] = useState(SPORT_MODES['soccer'].defaultFormation);
    const [kitColor, setKitColor] = useState('#1e293b');
    const [managerName, setManagerName] = useState('Director Técnico');
    const [pitchPlayers, setPitchPlayers] = useState([]);

    // --- ESTADOS EXCLUSIVOS: ZONAS DE ANOTACIÓN (TOCHO/AMERICANO) ---
    const [leftEndzoneText, setLeftEndzoneText] = useState('LOCAL');
    const [rightEndzoneText, setRightEndzoneText] = useState('VISITA');
    const [leftEndzoneLogoUrl, setLeftEndzoneLogoUrl] = useState('');
    const [rightEndzoneLogoUrl, setRightEndzoneLogoUrl] = useState('');
    
    // --- ESTADO DE SECUENCIA TV ---
    const [isSequenceRunning, setIsSequenceRunning] = useState(false);
    const [presentationTime, setPresentationTime] = useState(8); 
    const sequenceRunningRef = useRef(false);

    useEffect(() => {
        loadTeams();
        fetchLineup(teamType);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [teamType]);

    const loadTeams = async () => {
        const res = await GetTeams();
        if (res.success) setTeams(res.data);
    };

    const fetchLineup = async (type) => {
        const res = await GetLineup(type);
        if (res.success && res.data && res.data.teamId) {
            const data = res.data;
            const fetchedMode = data.gameMode || 'soccer';
            
            setGameMode(fetchedMode);
            setTeamId(data.teamId);
            setFormation(data.formation || SPORT_MODES[fetchedMode].defaultFormation);
            setKitColor(data.kitColor || '#1e293b');
            setManagerName(data.managerName || 'Director Técnico');
            
            setLeftEndzoneText(data.leftEndzoneText || 'LOCAL');
            setRightEndzoneText(data.rightEndzoneText || 'VISITA');
            setLeftEndzoneLogoUrl(data.leftEndzoneLogoUrl || '');
            setRightEndzoneLogoUrl(data.rightEndzoneLogoUrl || '');
            
            await loadTeamRoster(data.teamId);
            setPitchPlayers(data.players || []);
        } else {
            resetBoardState();
        }
    };

    const loadTeamRoster = async (id) => {
        if (!id) return;
        const res = await GetPlayersByTeam(id);
        if (res.success) setAvailablePlayers(res.data);
    };

    const resetBoardState = (mode = gameMode) => {
        setTeamId('');
        setFormation(SPORT_MODES[mode].defaultFormation);
        setKitColor('#1e293b');
        setManagerName('Director Técnico');
        setPitchPlayers([]);
        setAvailablePlayers([]);
        
        setLeftEndzoneText('LOCAL');
        setRightEndzoneText('VISITA');
        setLeftEndzoneLogoUrl('');
        setRightEndzoneLogoUrl('');
    };

    const handleTeamChange = async (newTeamId) => {
        // CORRECCIÓN 1: Si es el mismo equipo, no borramos a los jugadores accidentalmente
        if (newTeamId === teamId) return;

        setManagerName('Director Técnico'); 
        setPitchPlayers([]);
        setTeamId(newTeamId);
        
        if (newTeamId) {
            await loadTeamRoster(newTeamId);
            applyFormationTemplate(formation, gameMode);
        }
    };

    const handleGameModeChange = (newMode) => {
        if (pitchPlayers.length > 0) {
            if (!window.confirm("Cambiar de deporte reiniciará las posiciones en la pizarra. ¿Deseas continuar?")) {
                return;
            }
        }
        setGameMode(newMode);
        resetBoardState(newMode);
        applyFormationTemplate(SPORT_MODES[newMode].defaultFormation, newMode);
    };

    const applyFormationTemplate = (formName, currentMode = gameMode) => {
        setFormation(formName);
        const coords = FORMATIONS[currentMode][formName];
        if (!coords) return;

        const newPitch = coords.map((c, index) => {
            const existingPlayer = pitchPlayers[index];
            return {
                playerId: existingPlayer ? existingPlayer.playerId : '',
                name: existingPlayer ? existingPlayer.name : 'VACÍO',
                dorsal: existingPlayer ? existingPlayer.dorsal : 0,
                isCaptain: existingPlayer ? existingPlayer.isCaptain : false,
                positionX: teamType === 'Local' ? c.l : 100 - c.l, 
                positionY: c.t
            };
        });
        setPitchPlayers(newPitch);
    };

    const updatePitchPlayer = (index, playerId) => {
        const playerObj = availablePlayers.find(p => p.id === parseInt(playerId));
        if (!playerObj) return;

        const newPitch = [...pitchPlayers];
        newPitch[index] = {
            ...newPitch[index],
            playerId: playerObj.id,
            name: playerObj.name,
            dorsal: playerObj.dorsal
        };
        setPitchPlayers(newPitch);
    };

    const setCaptain = (index) => {
        const newPitch = pitchPlayers.map((p, i) => ({ ...p, isCaptain: i === index }));
        setPitchPlayers(newPitch);
    };

    const handleDragStart = (e, index) => { e.dataTransfer.setData('sourceIndex', index); };

    const handleDrop = (e, targetIndex) => {
        const sourceIndex = parseInt(e.dataTransfer.getData('sourceIndex'));
        if (sourceIndex === targetIndex || isNaN(sourceIndex)) return;

        const newPitch = [...pitchPlayers];
        const tempPlayer = { ...newPitch[sourceIndex] };
        
        newPitch[sourceIndex].playerId = newPitch[targetIndex].playerId;
        newPitch[sourceIndex].name = newPitch[targetIndex].name;
        newPitch[sourceIndex].dorsal = newPitch[targetIndex].dorsal;
        newPitch[sourceIndex].isCaptain = newPitch[targetIndex].isCaptain;

        newPitch[targetIndex].playerId = tempPlayer.playerId;
        newPitch[targetIndex].name = tempPlayer.name;
        newPitch[targetIndex].dorsal = tempPlayer.dorsal;
        newPitch[targetIndex].isCaptain = tempPlayer.isCaptain;

        setPitchPlayers(newPitch);
    };

    const handleSave = async () => {
        if (pitchPlayers.some(p => !p.playerId)) {
            showMessage(`Faltan asignar jugadores a las ${SPORT_MODES[gameMode].maxPlayers} posiciones.`, MESSAGE_TYPE.WARNING);
            return;
        }

        const payload = {
            teamType,
            teamId: parseInt(teamId),
            gameMode,
            formation,
            kitColor,
            managerName,
            leftEndzoneText,
            rightEndzoneText,
            leftEndzoneLogoUrl,
            rightEndzoneLogoUrl,
            players: pitchPlayers.map(p => ({
                playerId: p.playerId,
                isCaptain: p.isCaptain,
                positionX: p.positionX,
                positionY: p.positionY
            }))
        };

        const res = await SaveLineup(payload);
        if (res.success) {
            showMessage("Alineación guardada y sincronizada", MESSAGE_TYPE.SUCCESS);
        } else {
            showMessage(res.message, MESSAGE_TYPE.BAD);
        }
    };

    const firePresentation = async (action, playerId = null) => {
        await TriggerPresentation(action, playerId);
        if(action !== 'close' && action !== 'hide_board' && action !== 'show_board') {
            showMessage(`Presentando en pantalla...`, MESSAGE_TYPE.SUCCESS);
        }
    };

    // BOTONES DE VISIBILIDAD
    const toggleBoardVisibility = async (show) => {
        await TriggerPresentation(show ? 'show_board' : 'hide_board');
        showMessage(show ? "Pizarra VISIBLE en transmisión" : "Pizarra OCULTA en transmisión", MESSAGE_TYPE.SUCCESS);
    };

    const runFullSequence = async () => {
        if (sequenceRunningRef.current) return;
        
        sequenceRunningRef.current = true;
        setIsSequenceRunning(true);
        showMessage("Secuencia Automática Iniciada", MESSAGE_TYPE.SUCCESS);

        const sortedPlayers = [...pitchPlayers].sort((a, b) => a.positionX - b.positionX);

        for (let player of sortedPlayers) {
            if (!sequenceRunningRef.current) break; 
            if (!player.playerId) continue;
            
            await TriggerPresentation('show_player', player.playerId);
            
            for(let i = 0; i < presentationTime; i++) {
                if (!sequenceRunningRef.current) break;
                await new Promise(resolve => setTimeout(resolve, 1000));
            }
        }

        if (sequenceRunningRef.current) {
            await TriggerPresentation('show_dt', null);
            for(let i = 0; i < presentationTime; i++) {
                if (!sequenceRunningRef.current) break;
                await new Promise(resolve => setTimeout(resolve, 1000));
            }
        }

        if (sequenceRunningRef.current) {
            await TriggerPresentation('close', null);
            showMessage("Secuencia Finalizada", MESSAGE_TYPE.SUCCESS);
        }

        sequenceRunningRef.current = false;
        setIsSequenceRunning(false);
    };

    const abortSequence = async () => {
        sequenceRunningRef.current = false; 
        setIsSequenceRunning(false);
        await TriggerPresentation('close', null);
        showMessage("Presentación abortada", MESSAGE_TYPE.WARNING);
    };

    const getPitchStyle = () => {
        if(gameMode === 'basketball') return { backgroundColor: '#d68743', border: '2px solid white' };
        if(gameMode === 'flag_football') return { backgroundColor: '#2e5932', border: '2px dashed yellow' };
        return { backgroundColor: '#1a4d2e', border: '2px solid rgba(255,255,255,0.5)' };
    };

    return (
        <SecondaryBase actionToExecute={getOutOfTheDynamic}>
            <div className="container-fluid pb-5">
                <div className="text-center mb-4">
                    <h3 className="fw-bold"><i className="bi bi-diagram-3-fill"></i> Súper Lienzo: Alineación Multideporte</h3>
                    <p className="text-muted small">Configura la táctica y lanza la presentación estelar a la transmisión.</p>
                </div>

                <div className="row g-4">
                    {/* COLUMNA IZQUIERDA: Configuración */}
                    <div className="col-lg-4">
                        <div className="card shadow-sm border-0 rounded-4 mb-4">
                            <div className="card-header bg-dark text-white fw-bold d-flex justify-content-between align-items-center">
                                <span><i className="bi bi-gear-fill"></i> Configuración</span>
                                <span className="badge bg-primary">{SPORT_MODES[gameMode].name}</span>
                            </div>
                            <div className="card-body">
                                
                                <div className="mb-3 bg-light p-2 rounded border border-info">
                                    <label className="form-label small fw-bold text-info-emphasis">Modalidad Deportiva</label>
                                    <select className="form-select border-info" value={gameMode} onChange={(e) => handleGameModeChange(e.target.value)}>
                                        {Object.keys(SPORT_MODES).map(key => (
                                            <option key={key} value={key}>{SPORT_MODES[key].name}</option>
                                        ))}
                                    </select>
                                </div>

                                <div className="mb-3">
                                    <label className="form-label small fw-bold">Tipo de Equipo</label>
                                    <select className="form-select" value={teamType} onChange={(e) => setTeamType(e.target.value)}>
                                        <option value="Local">Local</option>
                                        <option value="Away">Visitante</option>
                                    </select>
                                </div>
                                <div className="mb-3">
                                    <label className="form-label small fw-bold">Seleccionar Equipo de BD</label>
                                    <select className="form-select" value={teamId} onChange={(e) => handleTeamChange(e.target.value)}>
                                        <option value="">-- Elige un equipo --</option>
                                        {teams.map(t => <option key={t.id} value={t.id}>{t.name}</option>)}
                                    </select>
                                </div>
                                <div className="mb-3">
                                    <label className="form-label small fw-bold">Formación ({SPORT_MODES[gameMode].maxPlayers} Jugadores)</label>
                                    <select className="form-select" value={formation} onChange={(e) => applyFormationTemplate(e.target.value)}>
                                        {Object.keys(FORMATIONS[gameMode]).map(f => <option key={f} value={f}>{f}</option>)}
                                    </select>
                                </div>
                                <div className="row g-2 mb-3">
                                    <div className="col-6">
                                        <label className="form-label small fw-bold">Color Uniforme</label>
                                        <input type="color" className="form-control form-control-color w-100" value={kitColor} onChange={(e) => setKitColor(e.target.value)} />
                                    </div>
                                    <div className="col-6">
                                        <label className="form-label small fw-bold">Nombre del DT</label>
                                        <input type="text" className="form-control" value={managerName} onChange={(e) => setManagerName(e.target.value)} placeholder="Ej. Guardiola" />
                                    </div>
                                </div>

                                {gameMode === 'flag_football' && (
                                    <div className="border border-success rounded p-2 mb-3 bg-light">
                                        <label className="form-label small fw-bold text-success mb-2"><i className="bi bi-flag-fill"></i> Zonas de Anotación (Endzones)</label>
                                        <div className="row g-2 mb-2">
                                            <div className="col-6">
                                                <input type="text" className="form-control form-control-sm" placeholder="Texto Izq (LOCAL)" value={leftEndzoneText} onChange={e => setLeftEndzoneText(e.target.value)} />
                                            </div>
                                            <div className="col-6">
                                                <input type="text" className="form-control form-control-sm" placeholder="Texto Der (VISITA)" value={rightEndzoneText} onChange={e => setRightEndzoneText(e.target.value)} />
                                            </div>
                                        </div>
                                        <div className="row g-2">
                                            <div className="col-6">
                                                <input type="text" className="form-control form-control-sm" placeholder="Logo Izq (vipers.png)" value={leftEndzoneLogoUrl} onChange={e => setLeftEndzoneLogoUrl(e.target.value)} />
                                            </div>
                                            <div className="col-6">
                                                <input type="text" className="form-control form-control-sm" placeholder="Logo Der (aguilas.png)" value={rightEndzoneLogoUrl} onChange={e => setRightEndzoneLogoUrl(e.target.value)} />
                                            </div>
                                        </div>
                                        <div className="form-text text-muted" style={{ fontSize: '0.65rem' }}>Escribe solo el nombre del archivo. El archivo debe estar en /img/games/lineup/teams/</div>
                                    </div>
                                )}

                                <button className="btn btn-success w-100 fw-bold shadow-sm" onClick={handleSave}>
                                    <i className="bi bi-cloud-arrow-up-fill"></i> Guardar y Sincronizar Pantalla
                                </button>
                            </div>
                        </div>

                        {/* PANEL DE SECUENCIA TV */}
                        <div className="card shadow-sm border-0 rounded-4 bg-light border border-warning">
                            <div className="card-body text-center">
                                <h6 className="fw-bold text-warning mb-3"><i className="bi bi-camera-video-fill"></i> Máster de Transmisión</h6>
                                
                                {/* NUEVOS BOTONES DE VISIBILIDAD */}
                                <div className="d-flex gap-2 mb-3">
                                    <button className="btn btn-outline-primary w-50 fw-bold btn-sm shadow-sm" onClick={() => toggleBoardVisibility(true)}>
                                        <i className="bi bi-eye-fill"></i> Mostrar Pizarra
                                    </button>
                                    <button className="btn btn-outline-secondary w-50 fw-bold btn-sm shadow-sm" onClick={() => toggleBoardVisibility(false)}>
                                        <i className="bi bi-eye-slash-fill"></i> Ocultar Pizarra
                                    </button>
                                </div>

                                <div className="d-flex align-items-center justify-content-center gap-2 mb-3">
                                    <span className="small fw-bold text-muted">Duración por jugador (s):</span>
                                    <input type="number" className="form-control text-center w-25" value={presentationTime} onChange={(e) => setPresentationTime(e.target.value)} min="5" max="20" />
                                </div>
                                <button 
                                    className={`btn w-100 fw-bold ${isSequenceRunning ? 'btn-danger' : 'btn-warning'}`} 
                                    onClick={runFullSequence}
                                    disabled={isSequenceRunning || pitchPlayers.length === 0}
                                >
                                    {isSequenceRunning ? <><i className="bi bi-hourglass-split"></i> Secuencia en Curso...</> : <><i className="bi bi-play-circle-fill"></i> Lanzar Secuencia TV</>}
                                </button>
                                <button className="btn btn-outline-danger w-100 fw-bold mt-2 btn-sm" onClick={abortSequence}>
                                    <i className="bi bi-x-circle-fill"></i> Detener y Forzar Cierre
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* COLUMNA DERECHA: Pizarra Táctica */}
                    <div className="col-lg-8">
                        <div className="card shadow-sm border-0 rounded-4 h-100">
                            <div className="card-header bg-success text-white fw-bold d-flex justify-content-between align-items-center">
                                <span><i className={`bi ${SPORT_MODES[gameMode].icon}`}></i> Pizarra Interactiva</span>
                                <span className="badge bg-dark">Ataca hacia: {teamType === 'Local' ? 'Derecha ➡' : '⬅ Izquierda'}</span>
                            </div>
                            
                            <div className="card-body rounded-bottom position-relative" style={{ minHeight: '550px', overflow: 'hidden', ...getPitchStyle() }}>
                                
                                {pitchPlayers.map((player, idx) => (
                                    <div 
                                        key={`${player.playerId}-${idx}`}
                                        draggable
                                        onDragStart={(e) => handleDragStart(e, idx)}
                                        onDragOver={(e) => e.preventDefault()}
                                        onDrop={(e) => handleDrop(e, idx)}
                                        className="position-absolute d-flex flex-column align-items-center"
                                        style={{ 
                                            left: `${player.positionX}%`, top: `${player.positionY}%`, 
                                            transform: 'translate(-50%, -50%)', cursor: 'grab', zIndex: 10 
                                        }}
                                    >
                                        <div className="rounded-circle d-flex align-items-center justify-content-center shadow" style={{ width: '35px', height: '35px', backgroundColor: kitColor, border: '2px solid white', color: 'white', fontWeight: 'bold', fontSize: '0.9rem', position: 'relative' }}>
                                            {player.dorsal || '#'}
                                            {player.isCaptain && <span className="position-absolute bg-warning text-dark rounded-circle" style={{ width: '14px', height: '14px', fontSize: '0.6rem', bottom: '-2px', right: '-2px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>C</span>}
                                        </div>
                                        
                                        <div className="mt-1 bg-secondary rounded px-1 shadow-sm" style={{ minWidth: '100px' }}>
                                            <select 
                                                className="form-select form-select-sm border-0 bg-transparent text-white text-center p-0" 
                                                style={{ fontSize: '0.75rem', fontWeight: 'bold', boxShadow: 'none' }}
                                                value={player.playerId} 
                                                onChange={(e) => updatePitchPlayer(idx, e.target.value)}
                                            >
                                                <option value="" className="text-dark">Seleccionar...</option>
                                                {availablePlayers.map(ap => (
                                                    <option key={ap.id} value={ap.id} className="text-dark">{ap.dorsal} - {ap.name}</option>
                                                ))}
                                            </select>
                                        </div>
                                        
                                        <div className="d-flex gap-1 mt-1 opacity-75">
                                            <button className="btn btn-sm btn-dark border-secondary p-0 px-1" style={{ fontSize: '0.6rem' }} onClick={() => setCaptain(idx)} title="Hacer Capitán">©</button>
                                            <button className="btn btn-sm btn-info p-0 px-1" style={{ fontSize: '0.6rem' }} onClick={() => firePresentation('show_player', player.playerId)} disabled={!player.playerId} title="Presentar en Pantalla"><i className="bi bi-play-fill text-white"></i></button>
                                        </div>
                                    </div>
                                ))}

                                <div className="position-absolute bottom-0 start-0 p-3">
                                    <button className="btn btn-sm btn-dark border-light d-flex align-items-center gap-2 shadow" onClick={() => firePresentation('show_dt')}>
                                        <div className="rounded-circle bg-secondary d-flex align-items-center justify-content-center text-white" style={{ width: '25px', height: '25px', fontSize: '0.7rem' }}>
                                            {gameMode === 'basketball' ? 'HC' : 'DT'}
                                        </div>
                                        Presentar: {managerName}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </SecondaryBase>
    );
};

export { Lineup };









// // Funcional
// import React, { useEffect, useState, useRef } from 'react';
// import { SecondaryBase } from '../Commons/SecondaryBase';
// import { useFloatMessage, MESSAGE_TYPE } from '../../Providers/FloatMessage';

// // Importamos la Lógica de Negocio
// import { GetLineup, SaveLineup, TriggerPresentation } from '../../../utilities/BL/Lineup';
// import { GetTeams, GetPlayersByTeam } from '../../../utilities/BL/SportPlayer';

// // --- CONFIGURACIÓN MULTIDEPORTE ---
// const SPORT_MODES = {
//     'soccer': { name: 'Fútbol 11', maxPlayers: 11, defaultFormation: '4-4-2', icon: 'bi-record-circle' },
//     'basketball': { name: 'Básquetbol (5v5)', maxPlayers: 5, defaultFormation: '4-Out 1-In', icon: 'bi-dribbble' },
//     'flag_football': { name: 'Tocho Bandera (5v5)', maxPlayers: 5, defaultFormation: 'ofensiva-abierta', icon: 'bi-vinyl-fill' }
// };

// // --- DICCIONARIO MAESTRO DE FORMACIONES ---
// const FORMATIONS = {
//     'soccer': {
//         '4-4-2': [{l:5, t:50}, {l:22, t:90}, {l:22, t:10}, {l:18, t:65}, {l:18, t:35}, {l:50, t:90}, {l:50, t:10}, {l:45, t:65}, {l:45, t:35}, {l:75, t:60}, {l:75, t:40}],
//         '4-2-3-1': [{l:5, t:50}, {l:22, t:90}, {l:22, t:10}, {l:18, t:65}, {l:18, t:35}, {l:40, t:65}, {l:40, t:35}, {l:60, t:90}, {l:60, t:10}, {l:60, t:50}, {l:80, t:50}],
//         '4-3-3': [{l:5, t:50}, {l:22, t:90}, {l:22, t:10}, {l:18, t:65}, {l:18, t:35}, {l:40, t:50}, {l:50, t:80}, {l:50, t:20}, {l:80, t:50}, {l:75, t:90}, {l:75, t:10}],
//         '3-5-2': [{l:5, t:50}, {l:18, t:50}, {l:18, t:80}, {l:18, t:20}, {l:35, t:50}, {l:45, t:90}, {l:45, t:10}, {l:55, t:70}, {l:55, t:30}, {l:75, t:55}, {l:75, t:45}],
//         '5-3-2': [{l:5, t:50}, {l:20, t:50}, {l:20, t:70}, {l:20, t:30}, {l:25, t:90}, {l:25, t:10}, {l:45, t:50}, {l:50, t:75}, {l:50, t:25}, {l:75, t:60}, {l:75, t:40}],
//         '5-4-1': [{l:5, t:50}, {l:20, t:50}, {l:20, t:70}, {l:20, t:30}, {l:25, t:90}, {l:25, t:10}, {l:45, t:70}, {l:45, t:30}, {l:50, t:90}, {l:50, t:10}, {l:75, t:50}]
//     },
//     'basketball': {
//         'Man-to-Man': [{l:32, t:50}, {l:22, t:25}, {l:22, t:75}, {l:10, t:35}, {l:10, t:65}],
//         '2-3 Zone': [{l:26, t:35}, {l:26, t:65}, {l:12, t:15}, {l:12, t:85}, {l:8, t:50}],
//         '3-2 Zone': [{l:28, t:50}, {l:22, t:25}, {l:22, t:75}, {l:10, t:35}, {l:10, t:65}],
//         '4-Out 1-In': [{l:38, t:35}, {l:38, t:65}, {l:15, t:10}, {l:15, t:90}, {l:12, t:50}],
//         '5-Out': [{l:42, t:50}, {l:32, t:18}, {l:32, t:82}, {l:10, t:10}, {l:10, t:90}]
//     },
//     'flag_football': {
//         'ofensiva-abierta': [{l: 25, t: 50}, {l: 40, t: 50}, {l: 40, t: 20}, {l: 40, t: 80}, {l: 40, t: 35}],
//         'ofensiva-gemelos': [{l: 25, t: 50}, {l: 40, t: 50}, {l: 40, t: 20}, {l: 40, t: 70}, {l: 40, t: 85}],
//         'defensiva-zona': [{l: 60, t: 50}, {l: 55, t: 30}, {l: 55, t: 70}, {l: 75, t: 35}, {l: 75, t: 65}],
//         'defensiva-hombre': [{l: 60, t: 50}, {l: 55, t: 20}, {l: 55, t: 80}, {l: 55, t: 35}, {l: 80, t: 50}]
//     }
// };

// const Lineup = ({ getOutOfTheDynamic }) => {
//     const { showMessage } = useFloatMessage();

//     // --- ESTADOS DE CONFIGURACIÓN ---
//     const [teamType, setTeamType] = useState('Local'); 
//     const [gameMode, setGameMode] = useState('soccer'); 
//     const [teams, setTeams] = useState([]);
//     const [availablePlayers, setAvailablePlayers] = useState([]);
    
//     // --- ESTADO TÁCTICO ---
//     const [teamId, setTeamId] = useState('');
//     const [formation, setFormation] = useState(SPORT_MODES['soccer'].defaultFormation);
//     const [kitColor, setKitColor] = useState('#1e293b');
//     const [managerName, setManagerName] = useState('Director Técnico');
//     const [pitchPlayers, setPitchPlayers] = useState([]);

//     // --- ESTADOS EXCLUSIVOS: ZONAS DE ANOTACIÓN (TOCHO/AMERICANO) ---
//     const [leftEndzoneText, setLeftEndzoneText] = useState('LOCAL');
//     const [rightEndzoneText, setRightEndzoneText] = useState('VISITA');
//     const [leftEndzoneLogoUrl, setLeftEndzoneLogoUrl] = useState('');
//     const [rightEndzoneLogoUrl, setRightEndzoneLogoUrl] = useState('');
    
//     // --- ESTADO DE SECUENCIA TV ---
//     const [isSequenceRunning, setIsSequenceRunning] = useState(false);
//     const [presentationTime, setPresentationTime] = useState(8); 
//     const sequenceRunningRef = useRef(false);

//     // -------------------------------------------------------------------------
//     // 1. CARGA INICIAL Y CAMBIOS MAESTROS
//     // -------------------------------------------------------------------------
//     useEffect(() => {
//         loadTeams();
//         fetchLineup(teamType);
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//     }, [teamType]);

//     const loadTeams = async () => {
//         const res = await GetTeams();
//         if (res.success) setTeams(res.data);
//     };

//     const fetchLineup = async (type) => {
//         const res = await GetLineup(type);
//         if (res.success && res.data && res.data.teamId) {
//             const data = res.data;
//             const fetchedMode = data.gameMode || 'soccer';
            
//             setGameMode(fetchedMode);
//             setTeamId(data.teamId);
//             setFormation(data.formation || SPORT_MODES[fetchedMode].defaultFormation);
//             setKitColor(data.kitColor || '#1e293b');
//             setManagerName(data.managerName || 'Director Técnico');
            
//             // Cargar Endzones
//             setLeftEndzoneText(data.leftEndzoneText || 'LOCAL');
//             setRightEndzoneText(data.rightEndzoneText || 'VISITA');
//             setLeftEndzoneLogoUrl(data.leftEndzoneLogoUrl || '');
//             setRightEndzoneLogoUrl(data.rightEndzoneLogoUrl || '');
            
//             await loadTeamRoster(data.teamId);
//             setPitchPlayers(data.players || []);
//         } else {
//             resetBoardState();
//         }
//     };

//     const loadTeamRoster = async (id) => {
//         if (!id) return;
//         const res = await GetPlayersByTeam(id);
//         if (res.success) setAvailablePlayers(res.data);
//     };

//     const resetBoardState = (mode = gameMode) => {
//         setTeamId('');
//         setFormation(SPORT_MODES[mode].defaultFormation);
//         setKitColor('#1e293b');
//         setManagerName('Director Técnico');
//         setPitchPlayers([]);
//         setAvailablePlayers([]);
        
//         // Reset Endzones
//         setLeftEndzoneText('LOCAL');
//         setRightEndzoneText('VISITA');
//         setLeftEndzoneLogoUrl('');
//         setRightEndzoneLogoUrl('');
//     };

//     const handleTeamChange = async (newTeamId) => {
//         setManagerName('Director Técnico'); 
//         setPitchPlayers([]);
//         setTeamId(newTeamId);
        
//         if (newTeamId) {
//             await loadTeamRoster(newTeamId);
//             applyFormationTemplate(formation, gameMode);
//         }
//     };

//     const handleGameModeChange = (newMode) => {
//         if (pitchPlayers.length > 0) {
//             if (!window.confirm("Cambiar de deporte reiniciará las posiciones en la pizarra. ¿Deseas continuar?")) {
//                 return;
//             }
//         }
//         setGameMode(newMode);
//         resetBoardState(newMode);
//         applyFormationTemplate(SPORT_MODES[newMode].defaultFormation, newMode);
//     };

//     // -------------------------------------------------------------------------
//     // 2. LÓGICA TÁCTICA 
//     // -------------------------------------------------------------------------
//     const applyFormationTemplate = (formName, currentMode = gameMode) => {
//         setFormation(formName);
//         const coords = FORMATIONS[currentMode][formName];
//         if (!coords) return;

//         const newPitch = coords.map((c, index) => {
//             const existingPlayer = pitchPlayers[index];
//             return {
//                 playerId: existingPlayer ? existingPlayer.playerId : '',
//                 name: existingPlayer ? existingPlayer.name : 'VACÍO',
//                 dorsal: existingPlayer ? existingPlayer.dorsal : 0,
//                 isCaptain: existingPlayer ? existingPlayer.isCaptain : false,
//                 positionX: teamType === 'Local' ? c.l : 100 - c.l, 
//                 positionY: c.t
//             };
//         });
//         setPitchPlayers(newPitch);
//     };

//     const updatePitchPlayer = (index, playerId) => {
//         const playerObj = availablePlayers.find(p => p.id === parseInt(playerId));
//         if (!playerObj) return;

//         const newPitch = [...pitchPlayers];
//         newPitch[index] = {
//             ...newPitch[index],
//             playerId: playerObj.id,
//             name: playerObj.name,
//             dorsal: playerObj.dorsal
//         };
//         setPitchPlayers(newPitch);
//     };

//     const setCaptain = (index) => {
//         const newPitch = pitchPlayers.map((p, i) => ({ ...p, isCaptain: i === index }));
//         setPitchPlayers(newPitch);
//     };

//     const handleDragStart = (e, index) => {
//         e.dataTransfer.setData('sourceIndex', index);
//     };

//     const handleDrop = (e, targetIndex) => {
//         const sourceIndex = parseInt(e.dataTransfer.getData('sourceIndex'));
//         if (sourceIndex === targetIndex || isNaN(sourceIndex)) return;

//         const newPitch = [...pitchPlayers];
//         const tempPlayer = { ...newPitch[sourceIndex] };
        
//         newPitch[sourceIndex].playerId = newPitch[targetIndex].playerId;
//         newPitch[sourceIndex].name = newPitch[targetIndex].name;
//         newPitch[sourceIndex].dorsal = newPitch[targetIndex].dorsal;
//         newPitch[sourceIndex].isCaptain = newPitch[targetIndex].isCaptain;

//         newPitch[targetIndex].playerId = tempPlayer.playerId;
//         newPitch[targetIndex].name = tempPlayer.name;
//         newPitch[targetIndex].dorsal = tempPlayer.dorsal;
//         newPitch[targetIndex].isCaptain = tempPlayer.isCaptain;

//         setPitchPlayers(newPitch);
//     };

//     // -------------------------------------------------------------------------
//     // 3. EVENTOS WEBSOCKET Y PERSISTENCIA
//     // -------------------------------------------------------------------------
//     const handleSave = async () => {
//         if (pitchPlayers.some(p => !p.playerId)) {
//             showMessage(`Faltan asignar jugadores a las ${SPORT_MODES[gameMode].maxPlayers} posiciones.`, MESSAGE_TYPE.WARNING);
//             return;
//         }

//         const payload = {
//             teamType,
//             teamId: parseInt(teamId),
//             gameMode,
//             formation,
//             kitColor,
//             managerName,
//             // Agregamos los campos de las Endzones al payload
//             leftEndzoneText,
//             rightEndzoneText,
//             leftEndzoneLogoUrl,
//             rightEndzoneLogoUrl,
//             players: pitchPlayers.map(p => ({
//                 playerId: p.playerId,
//                 isCaptain: p.isCaptain,
//                 positionX: p.positionX,
//                 positionY: p.positionY
//             }))
//         };

//         const res = await SaveLineup(payload);
//         if (res.success) {
//             showMessage("Alineación guardada y sincronizada", MESSAGE_TYPE.SUCCESS);
//         } else {
//             showMessage(res.message, MESSAGE_TYPE.BAD);
//         }
//     };

//     const firePresentation = async (action, playerId = null) => {
//         await TriggerPresentation(action, playerId);
//         if(action !== 'close') showMessage(`Presentando en pantalla...`, MESSAGE_TYPE.SUCCESS);
//     };

//     const runFullSequence = async () => {
//         if (sequenceRunningRef.current) return;
        
//         sequenceRunningRef.current = true;
//         setIsSequenceRunning(true);
//         showMessage("Secuencia Automática Iniciada", MESSAGE_TYPE.SUCCESS);

//         const sortedPlayers = [...pitchPlayers].sort((a, b) => a.positionX - b.positionX);

//         for (let player of sortedPlayers) {
//             if (!sequenceRunningRef.current) break; 
//             if (!player.playerId) continue;
            
//             await TriggerPresentation('show_player', player.playerId);
            
//             for(let i = 0; i < presentationTime; i++) {
//                 if (!sequenceRunningRef.current) break;
//                 await new Promise(resolve => setTimeout(resolve, 1000));
//             }
//         }

//         if (sequenceRunningRef.current) {
//             await TriggerPresentation('show_dt', null);
//             for(let i = 0; i < presentationTime; i++) {
//                 if (!sequenceRunningRef.current) break;
//                 await new Promise(resolve => setTimeout(resolve, 1000));
//             }
//         }

//         if (sequenceRunningRef.current) {
//             await TriggerPresentation('close', null);
//             showMessage("Secuencia Finalizada", MESSAGE_TYPE.SUCCESS);
//         }

//         sequenceRunningRef.current = false;
//         setIsSequenceRunning(false);
//     };

//     const abortSequence = async () => {
//         sequenceRunningRef.current = false; 
//         setIsSequenceRunning(false);
//         await TriggerPresentation('close', null);
//         showMessage("Presentación abortada", MESSAGE_TYPE.WARNING);
//     };

//     // -------------------------------------------------------------------------
//     // RENDERIZADO DEL PANEL
//     // -------------------------------------------------------------------------
//     const getPitchStyle = () => {
//         if(gameMode === 'basketball') return { backgroundColor: '#d68743', border: '2px solid white' };
//         if(gameMode === 'flag_football') return { backgroundColor: '#2e5932', border: '2px dashed yellow' };
//         return { backgroundColor: '#1a4d2e', border: '2px solid rgba(255,255,255,0.5)' };
//     };

//     return (
//         <SecondaryBase actionToExecute={getOutOfTheDynamic}>
//             <div className="container-fluid pb-5">
//                 <div className="text-center mb-4">
//                     <h3 className="fw-bold"><i className="bi bi-diagram-3-fill"></i> Súper Lienzo: Alineación Multideporte</h3>
//                     <p className="text-muted small">Configura la táctica y lanza la presentación estelar a la transmisión.</p>
//                 </div>

//                 <div className="row g-4">
//                     {/* COLUMNA IZQUIERDA: Configuración */}
//                     <div className="col-lg-4">
//                         <div className="card shadow-sm border-0 rounded-4 mb-4">
//                             <div className="card-header bg-dark text-white fw-bold d-flex justify-content-between align-items-center">
//                                 <span><i className="bi bi-gear-fill"></i> Configuración</span>
//                                 <span className="badge bg-primary">{SPORT_MODES[gameMode].name}</span>
//                             </div>
//                             <div className="card-body">
                                
//                                 <div className="mb-3 bg-light p-2 rounded border border-info">
//                                     <label className="form-label small fw-bold text-info-emphasis">Modalidad Deportiva</label>
//                                     <select className="form-select border-info" value={gameMode} onChange={(e) => handleGameModeChange(e.target.value)}>
//                                         {Object.keys(SPORT_MODES).map(key => (
//                                             <option key={key} value={key}>{SPORT_MODES[key].name}</option>
//                                         ))}
//                                     </select>
//                                 </div>

//                                 <div className="mb-3">
//                                     <label className="form-label small fw-bold">Tipo de Equipo</label>
//                                     <select className="form-select" value={teamType} onChange={(e) => setTeamType(e.target.value)}>
//                                         <option value="Local">Local</option>
//                                         <option value="Away">Visitante</option>
//                                     </select>
//                                 </div>
//                                 <div className="mb-3">
//                                     <label className="form-label small fw-bold">Seleccionar Equipo de BD</label>
//                                     <select className="form-select" value={teamId} onChange={(e) => handleTeamChange(e.target.value)}>
//                                         <option value="">-- Elige un equipo --</option>
//                                         {teams.map(t => <option key={t.id} value={t.id}>{t.name}</option>)}
//                                     </select>
//                                 </div>
//                                 <div className="mb-3">
//                                     <label className="form-label small fw-bold">Formación ({SPORT_MODES[gameMode].maxPlayers} Jugadores)</label>
//                                     <select className="form-select" value={formation} onChange={(e) => applyFormationTemplate(e.target.value)}>
//                                         {Object.keys(FORMATIONS[gameMode]).map(f => <option key={f} value={f}>{f}</option>)}
//                                     </select>
//                                 </div>
//                                 <div className="row g-2 mb-3">
//                                     <div className="col-6">
//                                         <label className="form-label small fw-bold">Color Uniforme</label>
//                                         <input type="color" className="form-control form-control-color w-100" value={kitColor} onChange={(e) => setKitColor(e.target.value)} />
//                                     </div>
//                                     <div className="col-6">
//                                         <label className="form-label small fw-bold">Nombre del DT</label>
//                                         <input type="text" className="form-control" value={managerName} onChange={(e) => setManagerName(e.target.value)} placeholder="Ej. Guardiola" />
//                                     </div>
//                                 </div>

//                                 {/* ZONAS DE ANOTACIÓN (SOLO PARA TOCHO/AMERICANO) */}
//                                 {gameMode === 'flag_football' && (
//                                     <div className="border border-success rounded p-2 mb-3 bg-light">
//                                         <label className="form-label small fw-bold text-success mb-2"><i className="bi bi-flag-fill"></i> Zonas de Anotación (Endzones)</label>
//                                         <div className="row g-2 mb-2">
//                                             <div className="col-6">
//                                                 <input type="text" className="form-control form-control-sm" placeholder="Texto Izq (LOCAL)" value={leftEndzoneText} onChange={e => setLeftEndzoneText(e.target.value)} />
//                                             </div>
//                                             <div className="col-6">
//                                                 <input type="text" className="form-control form-control-sm" placeholder="Texto Der (VISITA)" value={rightEndzoneText} onChange={e => setRightEndzoneText(e.target.value)} />
//                                             </div>
//                                         </div>
//                                         <div className="row g-2">
//                                             <div className="col-6">
//                                                 <input type="text" className="form-control form-control-sm" placeholder="Logo Izq (vipers.png)" value={leftEndzoneLogoUrl} onChange={e => setLeftEndzoneLogoUrl(e.target.value)} />
//                                             </div>
//                                             <div className="col-6">
//                                                 <input type="text" className="form-control form-control-sm" placeholder="Logo Der (aguilas.png)" value={rightEndzoneLogoUrl} onChange={e => setRightEndzoneLogoUrl(e.target.value)} />
//                                             </div>
//                                         </div>
//                                         <div className="form-text text-muted" style={{ fontSize: '0.65rem' }}>Escribe solo el nombre del archivo. El archivo debe estar en /img/games/lineup/teams/</div>
//                                     </div>
//                                 )}

//                                 <button className="btn btn-success w-100 fw-bold shadow-sm" onClick={handleSave}>
//                                     <i className="bi bi-cloud-arrow-up-fill"></i> Guardar y Sincronizar Pantalla
//                                 </button>
//                             </div>
//                         </div>

//                         {/* PANEL DE SECUENCIA TV */}
//                         <div className="card shadow-sm border-0 rounded-4 bg-light border border-warning">
//                             <div className="card-body text-center">
//                                 <h6 className="fw-bold text-warning mb-3"><i className="bi bi-camera-video-fill"></i> Máster de Transmisión</h6>
//                                 <div className="d-flex align-items-center justify-content-center gap-2 mb-3">
//                                     <span className="small fw-bold text-muted">Duración por jugador (s):</span>
//                                     <input type="number" className="form-control text-center w-25" value={presentationTime} onChange={(e) => setPresentationTime(e.target.value)} min="5" max="20" />
//                                 </div>
//                                 <button 
//                                     className={`btn w-100 fw-bold ${isSequenceRunning ? 'btn-danger' : 'btn-warning'}`} 
//                                     onClick={runFullSequence}
//                                     disabled={isSequenceRunning || pitchPlayers.length === 0}
//                                 >
//                                     {isSequenceRunning ? <><i className="bi bi-hourglass-split"></i> Secuencia en Curso...</> : <><i className="bi bi-play-circle-fill"></i> Lanzar Secuencia TV</>}
//                                 </button>
//                                 <button className="btn btn-outline-danger w-100 fw-bold mt-2 btn-sm" onClick={abortSequence}>
//                                     <i className="bi bi-x-circle-fill"></i> Detener y Forzar Cierre
//                                 </button>
//                             </div>
//                         </div>
//                     </div>

//                     {/* COLUMNA DERECHA: Pizarra Táctica */}
//                     <div className="col-lg-8">
//                         <div className="card shadow-sm border-0 rounded-4 h-100">
//                             <div className="card-header bg-success text-white fw-bold d-flex justify-content-between align-items-center">
//                                 <span><i className={`bi ${SPORT_MODES[gameMode].icon}`}></i> Pizarra Interactiva</span>
//                                 <span className="badge bg-dark">Ataca hacia: {teamType === 'Local' ? 'Derecha ➡' : '⬅ Izquierda'}</span>
//                             </div>
                            
//                             <div className="card-body rounded-bottom position-relative" style={{ minHeight: '550px', overflow: 'hidden', ...getPitchStyle() }}>
                                
//                                 {pitchPlayers.map((player, idx) => (
//                                     <div 
//                                         key={`${player.playerId}-${idx}`}
//                                         draggable
//                                         onDragStart={(e) => handleDragStart(e, idx)}
//                                         onDragOver={(e) => e.preventDefault()}
//                                         onDrop={(e) => handleDrop(e, idx)}
//                                         className="position-absolute d-flex flex-column align-items-center"
//                                         style={{ 
//                                             left: `${player.positionX}%`, top: `${player.positionY}%`, 
//                                             transform: 'translate(-50%, -50%)', cursor: 'grab', zIndex: 10 
//                                         }}
//                                     >
//                                         <div className="rounded-circle d-flex align-items-center justify-content-center shadow" style={{ width: '35px', height: '35px', backgroundColor: kitColor, border: '2px solid white', color: 'white', fontWeight: 'bold', fontSize: '0.9rem', position: 'relative' }}>
//                                             {player.dorsal || '#'}
//                                             {player.isCaptain && <span className="position-absolute bg-warning text-dark rounded-circle" style={{ width: '14px', height: '14px', fontSize: '0.6rem', bottom: '-2px', right: '-2px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>C</span>}
//                                         </div>
                                        
//                                         <div className="mt-1 bg-secondary rounded px-1 shadow-sm" style={{ minWidth: '100px' }}>
//                                             <select 
//                                                 className="form-select form-select-sm border-0 bg-transparent text-white text-center p-0" 
//                                                 style={{ fontSize: '0.75rem', fontWeight: 'bold', boxShadow: 'none' }}
//                                                 value={player.playerId} 
//                                                 onChange={(e) => updatePitchPlayer(idx, e.target.value)}
//                                             >
//                                                 <option value="" className="text-dark">Seleccionar...</option>
//                                                 {availablePlayers.map(ap => (
//                                                     <option key={ap.id} value={ap.id} className="text-dark">{ap.dorsal} - {ap.name}</option>
//                                                 ))}
//                                             </select>
//                                         </div>
                                        
//                                         <div className="d-flex gap-1 mt-1 opacity-75">
//                                             <button className="btn btn-sm btn-dark border-secondary p-0 px-1" style={{ fontSize: '0.6rem' }} onClick={() => setCaptain(idx)} title="Hacer Capitán">©</button>
//                                             <button className="btn btn-sm btn-info p-0 px-1" style={{ fontSize: '0.6rem' }} onClick={() => firePresentation('show_player', player.playerId)} disabled={!player.playerId} title="Presentar en Pantalla"><i className="bi bi-play-fill text-white"></i></button>
//                                         </div>
//                                     </div>
//                                 ))}

//                                 <div className="position-absolute bottom-0 start-0 p-3">
//                                     <button className="btn btn-sm btn-dark border-light d-flex align-items-center gap-2 shadow" onClick={() => firePresentation('show_dt')}>
//                                         <div className="rounded-circle bg-secondary d-flex align-items-center justify-content-center text-white" style={{ width: '25px', height: '25px', fontSize: '0.7rem' }}>
//                                             {gameMode === 'basketball' ? 'HC' : 'DT'}
//                                         </div>
//                                         Presentar: {managerName}
//                                     </button>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </SecondaryBase>
//     );
// };

// export { Lineup };










// Funcional
// import React, { useEffect, useState, useRef } from 'react';
// import { SecondaryBase } from '../Commons/SecondaryBase';
// import { useFloatMessage, MESSAGE_TYPE } from '../../Providers/FloatMessage';

// // Importamos la Lógica de Negocio
// import { GetLineup, SaveLineup, TriggerPresentation } from '../../../utilities/BL/Lineup';
// import { GetTeams, GetPlayersByTeam } from '../../../utilities/BL/SportPlayer';

// // --- CONFIGURACIÓN MULTIDEPORTE ---
// const SPORT_MODES = {
//     'soccer': { name: 'Fútbol 11', maxPlayers: 11, defaultFormation: '4-4-2', icon: 'bi-record-circle' },
//     'basketball': { name: 'Básquetbol (5v5)', maxPlayers: 5, defaultFormation: '4-Out 1-In', icon: 'bi-dribbble' },
//     'flag_football': { name: 'Tocho Bandera (5v5)', maxPlayers: 5, defaultFormation: 'ofensiva-abierta', icon: 'bi-vinyl-fill' }
// };

// // --- DICCIONARIO MAESTRO DE FORMACIONES ---
// const FORMATIONS = {
//     'soccer': {
//         '4-4-2': [{l:5, t:50}, {l:22, t:90}, {l:22, t:10}, {l:18, t:65}, {l:18, t:35}, {l:50, t:90}, {l:50, t:10}, {l:45, t:65}, {l:45, t:35}, {l:75, t:60}, {l:75, t:40}],
//         '4-2-3-1': [{l:5, t:50}, {l:22, t:90}, {l:22, t:10}, {l:18, t:65}, {l:18, t:35}, {l:40, t:65}, {l:40, t:35}, {l:60, t:90}, {l:60, t:10}, {l:60, t:50}, {l:80, t:50}],
//         '4-3-3': [{l:5, t:50}, {l:22, t:90}, {l:22, t:10}, {l:18, t:65}, {l:18, t:35}, {l:40, t:50}, {l:50, t:80}, {l:50, t:20}, {l:80, t:50}, {l:75, t:90}, {l:75, t:10}],
//         '3-5-2': [{l:5, t:50}, {l:18, t:50}, {l:18, t:80}, {l:18, t:20}, {l:35, t:50}, {l:45, t:90}, {l:45, t:10}, {l:55, t:70}, {l:55, t:30}, {l:75, t:55}, {l:75, t:45}],
//         '5-3-2': [{l:5, t:50}, {l:20, t:50}, {l:20, t:70}, {l:20, t:30}, {l:25, t:90}, {l:25, t:10}, {l:45, t:50}, {l:50, t:75}, {l:50, t:25}, {l:75, t:60}, {l:75, t:40}],
//         '5-4-1': [{l:5, t:50}, {l:20, t:50}, {l:20, t:70}, {l:20, t:30}, {l:25, t:90}, {l:25, t:10}, {l:45, t:70}, {l:45, t:30}, {l:50, t:90}, {l:50, t:10}, {l:75, t:50}]
//     },
//     'basketball': {
//         'Man-to-Man': [{l:32, t:50}, {l:22, t:25}, {l:22, t:75}, {l:10, t:35}, {l:10, t:65}],
//         '2-3 Zone': [{l:26, t:35}, {l:26, t:65}, {l:12, t:15}, {l:12, t:85}, {l:8, t:50}],
//         '3-2 Zone': [{l:28, t:50}, {l:22, t:25}, {l:22, t:75}, {l:10, t:35}, {l:10, t:65}],
//         '4-Out 1-In': [{l:38, t:35}, {l:38, t:65}, {l:15, t:10}, {l:15, t:90}, {l:12, t:50}],
//         '5-Out': [{l:42, t:50}, {l:32, t:18}, {l:32, t:82}, {l:10, t:10}, {l:10, t:90}]
//     },
//     'flag_football': {
//         'ofensiva-abierta': [{l: 25, t: 50}, {l: 40, t: 50}, {l: 40, t: 20}, {l: 40, t: 80}, {l: 40, t: 35}],
//         'ofensiva-gemelos': [{l: 25, t: 50}, {l: 40, t: 50}, {l: 40, t: 20}, {l: 40, t: 70}, {l: 40, t: 85}],
//         'defensiva-zona': [{l: 60, t: 50}, {l: 55, t: 30}, {l: 55, t: 70}, {l: 75, t: 35}, {l: 75, t: 65}],
//         'defensiva-hombre': [{l: 60, t: 50}, {l: 55, t: 20}, {l: 55, t: 80}, {l: 55, t: 35}, {l: 80, t: 50}]
//     }
// };


// const Lineup = ({ getOutOfTheDynamic }) => {
//     const { showMessage } = useFloatMessage();

//     // --- ESTADOS DE CONFIGURACIÓN ---
//     const [teamType, setTeamType] = useState('Local'); 
//     const [gameMode, setGameMode] = useState('soccer'); // Modalidad deportiva
//     const [teams, setTeams] = useState([]);
//     const [availablePlayers, setAvailablePlayers] = useState([]);
    
//     // --- ESTADO TÁCTICO ---
//     const [teamId, setTeamId] = useState('');
//     const [formation, setFormation] = useState(SPORT_MODES['soccer'].defaultFormation);
//     const [kitColor, setKitColor] = useState('#1e293b');
//     const [managerName, setManagerName] = useState('Director Técnico');
//     const [pitchPlayers, setPitchPlayers] = useState([]);
    
//     // --- ESTADO DE SECUENCIA TV ---
//     const [isSequenceRunning, setIsSequenceRunning] = useState(false);
//     const [presentationTime, setPresentationTime] = useState(8); 
//     const sequenceRunningRef = useRef(false);

//     // -------------------------------------------------------------------------
//     // 1. CARGA INICIAL Y CAMBIOS MAESTROS
//     // -------------------------------------------------------------------------
//     useEffect(() => {
//         loadTeams();
//         fetchLineup(teamType);
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//     }, [teamType]);

//     const loadTeams = async () => {
//         const res = await GetTeams();
//         if (res.success) setTeams(res.data);
//     };

//     const fetchLineup = async (type) => {
//         const res = await GetLineup(type);
//         if (res.success && res.data && res.data.teamId) {
//             const data = res.data;
//             const fetchedMode = data.gameMode || 'soccer';
            
//             setGameMode(fetchedMode);
//             setTeamId(data.teamId);
//             setFormation(data.formation || SPORT_MODES[fetchedMode].defaultFormation);
//             setKitColor(data.kitColor || '#1e293b');
//             setManagerName(data.managerName || 'Director Técnico');
            
//             await loadTeamRoster(data.teamId);
//             setPitchPlayers(data.players || []);
//         } else {
//             // Limpieza total al no encontrar registro
//             resetBoardState();
//         }
//     };

//     /**
//      * Función que se encarga de consultar la base de datos para traer a los jugadores del equipo seleccionado
//      * @param {*} id 
//      * @returns 
//      */
//     const loadTeamRoster = async (id) => {
//         if (!id) return;
//         const res = await GetPlayersByTeam(id);
//         if (res.success) setAvailablePlayers(res.data);
//     };

//     const resetBoardState = (mode = gameMode) => {
//         setTeamId('');
//         setFormation(SPORT_MODES[mode].defaultFormation);
//         setKitColor('#1e293b');
//         setManagerName('Director Técnico');
//         setPitchPlayers([]);
//         setAvailablePlayers([]);
//     };

//     // const handleTeamChange = async (newTeamId) => {
//     //     setManagerName('Director Técnico'); 
//     //     setPitchPlayers([]);
//     //     setTeamId(newTeamId);
        
//     //     if (newTeamId) {
//     //         await loadTeamRoster(newTeamId);
//     //         applyFormationTemplate(formation, mode);
//     //     }
//     // };

//     const handleTeamChange = async (newTeamId) => {
//         setManagerName('Director Técnico'); 
//         setPitchPlayers([]);
//         setTeamId(newTeamId);
        
//         if (newTeamId) {
//             await loadTeamRoster(newTeamId);
//             // CORRECCIÓN: Cambiamos 'mode' por 'gameMode'
//             applyFormationTemplate(formation, gameMode);
//         }
//     };

//     const handleGameModeChange = (newMode) => {
//         if (pitchPlayers.length > 0) {
//             if (!window.confirm("Cambiar de deporte reiniciará las posiciones en la pizarra. ¿Deseas continuar?")) {
//                 return;
//             }
//         }
//         setGameMode(newMode);
//         resetBoardState(newMode);
//         // Aplicar la formación por defecto del nuevo deporte
//         applyFormationTemplate(SPORT_MODES[newMode].defaultFormation, newMode);
//     };

//     // -------------------------------------------------------------------------
//     // 2. LÓGICA TÁCTICA 
//     // -------------------------------------------------------------------------
//     const applyFormationTemplate = (formName, currentMode = gameMode) => {
//         setFormation(formName);
//         const coords = FORMATIONS[currentMode][formName];
//         if (!coords) return;

//         const newPitch = coords.map((c, index) => {
//             const existingPlayer = pitchPlayers[index];
//             return {
//                 playerId: existingPlayer ? existingPlayer.playerId : '',
//                 name: existingPlayer ? existingPlayer.name : 'VACÍO',
//                 dorsal: existingPlayer ? existingPlayer.dorsal : 0,
//                 isCaptain: existingPlayer ? existingPlayer.isCaptain : false,
//                 positionX: teamType === 'Local' ? c.l : 100 - c.l, 
//                 positionY: c.t
//             };
//         });
//         setPitchPlayers(newPitch);
//     };

//     const updatePitchPlayer = (index, playerId) => {
//         const playerObj = availablePlayers.find(p => p.id === parseInt(playerId));
//         if (!playerObj) return;

//         const newPitch = [...pitchPlayers];
//         newPitch[index] = {
//             ...newPitch[index],
//             playerId: playerObj.id,
//             name: playerObj.name,
//             dorsal: playerObj.dorsal
//         };
//         setPitchPlayers(newPitch);
//     };

//     const setCaptain = (index) => {
//         const newPitch = pitchPlayers.map((p, i) => ({ ...p, isCaptain: i === index }));
//         setPitchPlayers(newPitch);
//     };

//     // --- DRAG AND DROP ---
//     const handleDragStart = (e, index) => {
//         e.dataTransfer.setData('sourceIndex', index);
//     };

//     const handleDrop = (e, targetIndex) => {
//         const sourceIndex = parseInt(e.dataTransfer.getData('sourceIndex'));
//         if (sourceIndex === targetIndex || isNaN(sourceIndex)) return;

//         const newPitch = [...pitchPlayers];
//         const tempPlayer = { ...newPitch[sourceIndex] };
        
//         // Swap datos, no coordenadas
//         newPitch[sourceIndex].playerId = newPitch[targetIndex].playerId;
//         newPitch[sourceIndex].name = newPitch[targetIndex].name;
//         newPitch[sourceIndex].dorsal = newPitch[targetIndex].dorsal;
//         newPitch[sourceIndex].isCaptain = newPitch[targetIndex].isCaptain;

//         newPitch[targetIndex].playerId = tempPlayer.playerId;
//         newPitch[targetIndex].name = tempPlayer.name;
//         newPitch[targetIndex].dorsal = tempPlayer.dorsal;
//         newPitch[targetIndex].isCaptain = tempPlayer.isCaptain;

//         setPitchPlayers(newPitch);
//     };

//     // -------------------------------------------------------------------------
//     // 3. EVENTOS WEBSOCKET Y PERSISTENCIA
//     // -------------------------------------------------------------------------
//     const handleSave = async () => {
//         if (pitchPlayers.some(p => !p.playerId)) {
//             showMessage(`Faltan asignar jugadores a las ${SPORT_MODES[gameMode].maxPlayers} posiciones.`, MESSAGE_TYPE.WARNING);
//             return;
//         }

//         const payload = {
//             teamType,
//             teamId: parseInt(teamId),
//             gameMode,
//             formation,
//             kitColor,
//             managerName,
//             players: pitchPlayers.map(p => ({
//                 playerId: p.playerId,
//                 isCaptain: p.isCaptain,
//                 positionX: p.positionX,
//                 positionY: p.positionY
//             }))
//         };

//         const res = await SaveLineup(payload);
//         if (res.success) {
//             showMessage("Alineación guardada y sincronizada", MESSAGE_TYPE.SUCCESS);
//         } else {
//             showMessage(res.message, MESSAGE_TYPE.BAD);
//         }
//     };

//     const firePresentation = async (action, playerId = null) => {
//         await TriggerPresentation(action, playerId);
//         if(action !== 'close') showMessage(`Presentando en pantalla...`, MESSAGE_TYPE.SUCCESS);
//     };

//     const runFullSequence = async () => {
//         if (sequenceRunningRef.current) return;
        
//         sequenceRunningRef.current = true;
//         setIsSequenceRunning(true);
//         showMessage("Secuencia Automática Iniciada", MESSAGE_TYPE.SUCCESS);

//         const sortedPlayers = [...pitchPlayers].sort((a, b) => a.positionX - b.positionX);

//         for (let player of sortedPlayers) {
//             if (!sequenceRunningRef.current) break; 
//             if (!player.playerId) continue;
            
//             await TriggerPresentation('show_player', player.playerId);
            
//             for(let i = 0; i < presentationTime; i++) {
//                 if (!sequenceRunningRef.current) break;
//                 await new Promise(resolve => setTimeout(resolve, 1000));
//             }
//         }

//         if (sequenceRunningRef.current) {
//             await TriggerPresentation('show_dt', null);
//             for(let i = 0; i < presentationTime; i++) {
//                 if (!sequenceRunningRef.current) break;
//                 await new Promise(resolve => setTimeout(resolve, 1000));
//             }
//         }

//         if (sequenceRunningRef.current) {
//             await TriggerPresentation('close', null);
//             showMessage("Secuencia Finalizada", MESSAGE_TYPE.SUCCESS);
//         }

//         sequenceRunningRef.current = false;
//         setIsSequenceRunning(false);
//     };

//     const abortSequence = async () => {
//         sequenceRunningRef.current = false; 
//         setIsSequenceRunning(false);
//         await TriggerPresentation('close', null);
//         showMessage("Presentación abortada", MESSAGE_TYPE.WARNING);
//     };

//     // -------------------------------------------------------------------------
//     // RENDERIZADO DEL PANEL
//     // -------------------------------------------------------------------------
    
//     // Generar fondo dinámico según el deporte
//     const getPitchStyle = () => {
//         if(gameMode === 'basketball') return { backgroundColor: '#d68743', border: '2px solid white' };
//         if(gameMode === 'flag_football') return { backgroundColor: '#2e5932', border: '2px dashed yellow' };
//         return { backgroundColor: '#1a4d2e', border: '2px solid rgba(255,255,255,0.5)' };
//     };

//     return (
//         <SecondaryBase actionToExecute={getOutOfTheDynamic}>
//             <div className="container-fluid pb-5">
//                 <div className="text-center mb-4">
//                     <h3 className="fw-bold"><i className="bi bi-diagram-3-fill"></i> Súper Lienzo: Alineación Multideporte</h3>
//                     <p className="text-muted small">Configura la táctica y lanza la presentación estelar a la transmisión.</p>
//                 </div>

//                 <div className="row g-4">
//                     {/* COLUMNA IZQUIERDA: Configuración */}
//                     <div className="col-lg-4">
//                         <div className="card shadow-sm border-0 rounded-4 mb-4">
//                             <div className="card-header bg-dark text-white fw-bold d-flex justify-content-between align-items-center">
//                                 <span><i className="bi bi-gear-fill"></i> Configuración</span>
//                                 <span className="badge bg-primary">{SPORT_MODES[gameMode].name}</span>
//                             </div>
//                             <div className="card-body">
                                
//                                 {/* SELECTOR MULTIDEPORTE */}
//                                 <div className="mb-3 bg-light p-2 rounded border border-info">
//                                     <label className="form-label small fw-bold text-info-emphasis">Modalidad Deportiva</label>
//                                     <select className="form-select border-info" value={gameMode} onChange={(e) => handleGameModeChange(e.target.value)}>
//                                         {Object.keys(SPORT_MODES).map(key => (
//                                             <option key={key} value={key}>{SPORT_MODES[key].name}</option>
//                                         ))}
//                                     </select>
//                                 </div>

//                                 <div className="mb-3">
//                                     <label className="form-label small fw-bold">Tipo de Equipo</label>
//                                     <select className="form-select" value={teamType} onChange={(e) => setTeamType(e.target.value)}>
//                                         <option value="Local">Local</option>
//                                         <option value="Away">Visitante</option>
//                                     </select>
//                                 </div>
//                                 <div className="mb-3">
//                                     <label className="form-label small fw-bold">Seleccionar Equipo de BD</label>
//                                     <select className="form-select" value={teamId} onChange={(e) => handleTeamChange(e.target.value)}>
//                                         <option value="">-- Elige un equipo --</option>
//                                         {teams.map(t => <option key={t.id} value={t.id}>{t.name}</option>)}
//                                     </select>
//                                 </div>
//                                 <div className="mb-3">
//                                     <label className="form-label small fw-bold">Formación ({SPORT_MODES[gameMode].maxPlayers} Jugadores)</label>
//                                     <select className="form-select" value={formation} onChange={(e) => applyFormationTemplate(e.target.value)}>
//                                         {Object.keys(FORMATIONS[gameMode]).map(f => <option key={f} value={f}>{f}</option>)}
//                                     </select>
//                                 </div>
//                                 <div className="row g-2 mb-3">
//                                     <div className="col-6">
//                                         <label className="form-label small fw-bold">Color Uniforme</label>
//                                         <input type="color" className="form-control form-control-color w-100" value={kitColor} onChange={(e) => setKitColor(e.target.value)} />
//                                     </div>
//                                     <div className="col-6">
//                                         <label className="form-label small fw-bold">Nombre del DT</label>
//                                         <input type="text" className="form-control" value={managerName} onChange={(e) => setManagerName(e.target.value)} placeholder="Ej. Guardiola" />
//                                     </div>
//                                 </div>
//                                 <button className="btn btn-success w-100 fw-bold shadow-sm" onClick={handleSave}>
//                                     <i className="bi bi-cloud-arrow-up-fill"></i> Guardar y Sincronizar Pantalla
//                                 </button>
//                             </div>
//                         </div>

//                         {/* PANEL DE SECUENCIA TV */}
//                         <div className="card shadow-sm border-0 rounded-4 bg-light border border-warning">
//                             <div className="card-body text-center">
//                                 <h6 className="fw-bold text-warning mb-3"><i className="bi bi-camera-video-fill"></i> Máster de Transmisión</h6>
//                                 <div className="d-flex align-items-center justify-content-center gap-2 mb-3">
//                                     <span className="small fw-bold text-muted">Duración por jugador (s):</span>
//                                     <input type="number" className="form-control text-center w-25" value={presentationTime} onChange={(e) => setPresentationTime(e.target.value)} min="5" max="20" />
//                                 </div>
//                                 <button 
//                                     className={`btn w-100 fw-bold ${isSequenceRunning ? 'btn-danger' : 'btn-warning'}`} 
//                                     onClick={runFullSequence}
//                                     disabled={isSequenceRunning || pitchPlayers.length === 0}
//                                 >
//                                     {isSequenceRunning ? <><i className="bi bi-hourglass-split"></i> Secuencia en Curso...</> : <><i className="bi bi-play-circle-fill"></i> Lanzar Secuencia TV</>}
//                                 </button>
//                                 <button className="btn btn-outline-danger w-100 fw-bold mt-2 btn-sm" onClick={abortSequence}>
//                                     <i className="bi bi-x-circle-fill"></i> Detener y Forzar Cierre
//                                 </button>
//                             </div>
//                         </div>
//                     </div>

//                     {/* COLUMNA DERECHA: Pizarra Táctica */}
//                     <div className="col-lg-8">
//                         <div className="card shadow-sm border-0 rounded-4 h-100">
//                             <div className="card-header bg-success text-white fw-bold d-flex justify-content-between align-items-center">
//                                 <span><i className={`bi ${SPORT_MODES[gameMode].icon}`}></i> Pizarra Interactiva</span>
//                                 <span className="badge bg-dark">Ataca hacia: {teamType === 'Local' ? 'Derecha ➡' : '⬅ Izquierda'}</span>
//                             </div>
                            
//                             {/* Pizarra Dinámica según deporte */}
//                             <div className="card-body rounded-bottom position-relative" style={{ minHeight: '550px', overflow: 'hidden', ...getPitchStyle() }}>
                                
//                                 {/* Renderizado de Posiciones */}
//                                 {pitchPlayers.map((player, idx) => (
//                                     <div 
//                                         key={`${player.playerId}-${idx}`}
//                                         draggable
//                                         onDragStart={(e) => handleDragStart(e, idx)}
//                                         onDragOver={(e) => e.preventDefault()}
//                                         onDrop={(e) => handleDrop(e, idx)}
//                                         className="position-absolute d-flex flex-column align-items-center"
//                                         style={{ 
//                                             left: `${player.positionX}%`, top: `${player.positionY}%`, 
//                                             transform: 'translate(-50%, -50%)', cursor: 'grab', zIndex: 10 
//                                         }}
//                                     >
//                                         <div className="rounded-circle d-flex align-items-center justify-content-center shadow" style={{ width: '35px', height: '35px', backgroundColor: kitColor, border: '2px solid white', color: 'white', fontWeight: 'bold', fontSize: '0.9rem', position: 'relative' }}>
//                                             {player.dorsal || '#'}
//                                             {player.isCaptain && <span className="position-absolute bg-warning text-dark rounded-circle" style={{ width: '14px', height: '14px', fontSize: '0.6rem', bottom: '-2px', right: '-2px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>C</span>}
//                                         </div>
                                        
//                                         <div className="mt-1 bg-secondary rounded px-1 shadow-sm" style={{ minWidth: '100px' }}>
//                                             <select 
//                                                 className="form-select form-select-sm border-0 bg-transparent text-white text-center p-0" 
//                                                 style={{ fontSize: '0.75rem', fontWeight: 'bold', boxShadow: 'none' }}
//                                                 value={player.playerId} 
//                                                 onChange={(e) => updatePitchPlayer(idx, e.target.value)}
//                                             >
//                                                 <option value="" className="text-dark">Seleccionar...</option>
//                                                 {availablePlayers.map(ap => (
//                                                     <option key={ap.id} value={ap.id} className="text-dark">{ap.dorsal} - {ap.name}</option>
//                                                 ))}
//                                             </select>
//                                         </div>
                                        
//                                         <div className="d-flex gap-1 mt-1 opacity-75">
//                                             <button className="btn btn-sm btn-dark border-secondary p-0 px-1" style={{ fontSize: '0.6rem' }} onClick={() => setCaptain(idx)} title="Hacer Capitán">©</button>
//                                             <button className="btn btn-sm btn-info p-0 px-1" style={{ fontSize: '0.6rem' }} onClick={() => firePresentation('show_player', player.playerId)} disabled={!player.playerId} title="Presentar en Pantalla"><i className="bi bi-play-fill text-white"></i></button>
//                                         </div>
//                                     </div>
//                                 ))}

//                                 {/* DT CARD */}
//                                 <div className="position-absolute bottom-0 start-0 p-3">
//                                     <button className="btn btn-sm btn-dark border-light d-flex align-items-center gap-2 shadow" onClick={() => firePresentation('show_dt')}>
//                                         <div className="rounded-circle bg-secondary d-flex align-items-center justify-content-center text-white" style={{ width: '25px', height: '25px', fontSize: '0.7rem' }}>
//                                             {gameMode === 'basketball' ? 'HC' : 'DT'}
//                                         </div>
//                                         Presentar: {managerName}
//                                     </button>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </SecondaryBase>
//     );
// };

// export { Lineup };









// import React, { useEffect, useState, useRef } from 'react';
// import { SecondaryBase } from '../Commons/SecondaryBase';
// import { useFloatMessage, MESSAGE_TYPE } from '../../Providers/FloatMessage';

// // Importamos la Lógica de Negocio
// import { GetLineup, SaveLineup, TriggerPresentation } from '../../../utilities/BL/Lineup';
// import { GetTeams, GetPlayersByTeam } from '../../../utilities/BL/SportPlayer';


// // --- DICCIONARIO DE FORMACIONES (Mapeo de Coordenadas %) ---
// const FORMATIONS = {
//     '4-4-2': [{l:5, t:50}, {l:22, t:90}, {l:22, t:10}, {l:18, t:65}, {l:18, t:35}, {l:50, t:90}, {l:50, t:10}, {l:45, t:65}, {l:45, t:35}, {l:75, t:60}, {l:75, t:40}],
//     '4-2-3-1': [{l:5, t:50}, {l:22, t:90}, {l:22, t:10}, {l:18, t:65}, {l:18, t:35}, {l:40, t:65}, {l:40, t:35}, {l:60, t:90}, {l:60, t:10}, {l:60, t:50}, {l:80, t:50}],
//     '4-3-3': [{l:5, t:50}, {l:22, t:90}, {l:22, t:10}, {l:18, t:65}, {l:18, t:35}, {l:40, t:50}, {l:50, t:80}, {l:50, t:20}, {l:80, t:50}, {l:75, t:90}, {l:75, t:10}],
//     '3-5-2': [{l:5, t:50}, {l:18, t:50}, {l:18, t:80}, {l:18, t:20}, {l:35, t:50}, {l:45, t:90}, {l:45, t:10}, {l:55, t:70}, {l:55, t:30}, {l:75, t:55}, {l:75, t:45}],
//     '5-3-2': [{l:5, t:50}, {l:20, t:50}, {l:20, t:70}, {l:20, t:30}, {l:25, t:90}, {l:25, t:10}, {l:45, t:50}, {l:50, t:75}, {l:50, t:25}, {l:75, t:60}, {l:75, t:40}],
//     '5-4-1': [{l:5, t:50}, {l:20, t:50}, {l:20, t:70}, {l:20, t:30}, {l:25, t:90}, {l:25, t:10}, {l:45, t:70}, {l:45, t:30}, {l:50, t:90}, {l:50, t:10}, {l:75, t:50}]
// };


// const Lineup = ({ getOutOfTheDynamic }) => {
//     const { showMessage } = useFloatMessage();

//     // --- ESTADOS DE CONFIGURACIÓN ---
//     const [teamType, setTeamType] = useState('Local'); // 'Local' o 'Away'
//     const [teams, setTeams] = useState([]);
//     const [availablePlayers, setAvailablePlayers] = useState([]);
    
//     // --- ESTADO TÁCTICO (Formulario) ---
//     const [teamId, setTeamId] = useState('');
//     const [formation, setFormation] = useState('4-4-2');
//     const [kitColor, setKitColor] = useState('#1e293b');
//     const [managerName, setManagerName] = useState('Director Técnico');
    
//     // --- ESTADO DE JUGADORES EN CANCHA (Los 11 titulares) ---
//     const [pitchPlayers, setPitchPlayers] = useState([]);
    
//     // --- ESTADO DE SECUENCIA TV ---
//     const [isSequenceRunning, setIsSequenceRunning] = useState(false);
//     const [presentationTime, setPresentationTime] = useState(10); // Segundos por jugador

//     const sequenceRunningRef = useRef(false);

//     // -------------------------------------------------------------------------
//     // 1. CARGA INICIAL Y CAMBIO DE EQUIPO (LOCAL/AWAY)
//     // -------------------------------------------------------------------------
//     useEffect(() => {
//         loadTeams();
//         fetchLineup(teamType);
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//     }, [teamType]);

//     const loadTeams = async () => {
//         const res = await GetTeams();
//         if (res.success) setTeams(res.data);
//     };

//     // const fetchLineup = async (type) => {
//     //     const res = await GetLineup(type);
//     //     if (res.success && res.data.teamId) {
//     //         const data = res.data;
//     //         setTeamId(data.teamId);
//     //         setFormation(data.formation || '4-4-2');
//     //         setKitColor(data.kitColor || '#1e293b');
//     //         setManagerName(data.managerName || '');
            
//     //         // Cargar plantilla completa del equipo para poder sustituir
//     //         await loadTeamRoster(data.teamId);
            
//     //         // Poblar los titulares con sus coordenadas
//     //         setPitchPlayers(data.players || []);
//     //     } else {
//     //         // Si no hay alineación guardada, limpiamos el tablero
//     //         setTeamId('');
//     //         setPitchPlayers([]);
//     //         setAvailablePlayers([]);
//     //     }
//     // };

//     const fetchLineup = async (type) => {
//         const res = await GetLineup(type);
//         if (res.success && res.data && res.data.teamId) {
//             const data = res.data;
//             setTeamId(data.teamId);
//             setFormation(data.formation || '4-4-2');
//             setKitColor(data.kitColor || '#1e293b');
//             setManagerName(data.managerName || 'Director Técnico');
            
//             await loadTeamRoster(data.teamId);
//             setPitchPlayers(data.players || []);
//         } else {
//             // CORRECCIÓN: Limpiar completamente el estado para el nuevo tipo de equipo
//             setTeamId('');
//             setFormation('4-4-2');
//             setKitColor('#1e293b');
//             setManagerName('Director Técnico'); // Resetea el DT para el visitante
//             setPitchPlayers([]);
//             setAvailablePlayers([]);
//         }
//     };

//     const loadTeamRoster = async (id) => {
//         if (!id) return;
//         const res = await GetPlayersByTeam(id);
//         if (res.success) setAvailablePlayers(res.data);
//     };

//     const handleTeamChange = async (newTeamId) => {
//         // 1. Limpiar campos ANTES de traer los nuevos
//         setManagerName('Director Técnico'); 
//         setPitchPlayers([]);
        
//         // 2. Traer los nuevos
//         setTeamId(newTeamId);
//         await loadTeamRoster(newTeamId);
//         // Al cambiar de equipo, generamos 11 huecos vacíos basados en la formación actual
//         applyFormationTemplate(formation, newTeamId);
//     };

//     // -------------------------------------------------------------------------
//     // 2. LÓGICA TÁCTICA (Formaciones y Posiciones)
//     // -------------------------------------------------------------------------
//     const applyFormationTemplate = (formName, currentTeamId = teamId) => {
//         setFormation(formName);
//         const coords = FORMATIONS[formName];
//         if (!coords) return;

//         // Mantenemos los jugadores que ya están, o creamos huecos vacíos
//         const newPitch = coords.map((c, index) => {
//             const existingPlayer = pitchPlayers[index];
//             return {
//                 playerId: existingPlayer ? existingPlayer.playerId : '',
//                 name: existingPlayer ? existingPlayer.name : 'VACIÓ',
//                 dorsal: existingPlayer ? existingPlayer.dorsal : 0,
//                 isCaptain: existingPlayer ? existingPlayer.isCaptain : false,
//                 positionX: teamType === 'Local' ? c.l : 100 - c.l, // Invertir si ataca hacia la izquierda
//                 positionY: c.t
//             };
//         });
//         setPitchPlayers(newPitch);
//     };

//     const updatePitchPlayer = (index, playerId) => {
//         const playerObj = availablePlayers.find(p => p.id === parseInt(playerId));
//         if (!playerObj) return;

//         const newPitch = [...pitchPlayers];
//         newPitch[index] = {
//             ...newPitch[index],
//             playerId: playerObj.id,
//             name: playerObj.name,
//             dorsal: playerObj.dorsal
//         };
//         setPitchPlayers(newPitch);
//     };

//     const setCaptain = (index) => {
//         const newPitch = pitchPlayers.map((p, i) => ({ ...p, isCaptain: i === index }));
//         setPitchPlayers(newPitch);
//     };

//     // --- DRAG AND DROP (SWAP DE POSICIONES) ---
//     const handleDragStart = (e, index) => {
//         e.dataTransfer.setData('sourceIndex', index);
//     };

//     const handleDrop = (e, targetIndex) => {
//         const sourceIndex = parseInt(e.dataTransfer.getData('sourceIndex'));
//         if (sourceIndex === targetIndex) return;

//         // Intercambiamos solo los datos del jugador, NO sus coordenadas (para mantener la formación)
//         const newPitch = [...pitchPlayers];
//         const tempPlayer = { ...newPitch[sourceIndex] };
        
//         newPitch[sourceIndex].playerId = newPitch[targetIndex].playerId;
//         newPitch[sourceIndex].name = newPitch[targetIndex].name;
//         newPitch[sourceIndex].dorsal = newPitch[targetIndex].dorsal;
//         newPitch[sourceIndex].isCaptain = newPitch[targetIndex].isCaptain;

//         newPitch[targetIndex].playerId = tempPlayer.playerId;
//         newPitch[targetIndex].name = tempPlayer.name;
//         newPitch[targetIndex].dorsal = tempPlayer.dorsal;
//         newPitch[targetIndex].isCaptain = tempPlayer.isCaptain;

//         setPitchPlayers(newPitch);
//     };

//     // -------------------------------------------------------------------------
//     // 3. PERSISTENCIA Y EVENTOS (WebSocket)
//     // -------------------------------------------------------------------------
//     const handleSave = async () => {
//         // Validar que los 11 estén llenos
//         if (pitchPlayers.some(p => !p.playerId)) {
//             showMessage("Faltan jugadores en la alineación titular.", MESSAGE_TYPE.WARNING);
//             return;
//         }

//         const payload = {
//             teamType,
//             teamId: parseInt(teamId),
//             formation,
//             kitColor,
//             managerName,
//             players: pitchPlayers.map(p => ({
//                 playerId: p.playerId,
//                 isCaptain: p.isCaptain,
//                 positionX: p.positionX,
//                 positionY: p.positionY
//             }))
//         };

//         const res = await SaveLineup(payload);
//         if (res.success) {
//             showMessage("Alineación guardada y enviada a pantalla", MESSAGE_TYPE.SUCCESS);
//         } else {
//             showMessage(res.message, MESSAGE_TYPE.BAD);
//         }
//     };

//     const firePresentation = async (action, playerId = null) => {
//         await TriggerPresentation(action, playerId);
//         showMessage(`Evento disparado: ${action}`, MESSAGE_TYPE.SUCCESS);
//     };

//     // --- MACRO: SECUENCIA AUTOMÁTICA DE TV ---
//     // const runFullSequence = async () => {
//     //     if (isSequenceRunning) return;
//     //     setIsSequenceRunning(true);
//     //     showMessage("Secuencia Automática Iniciada", MESSAGE_TYPE.SUCCESS);

//     //     // Disparamos jugador por jugador de izquierda a derecha (usando positionX)
//     //     const sortedPlayers = [...pitchPlayers].sort((a, b) => a.positionX - b.positionX);

//     //     for (let player of sortedPlayers) {
//     //         if (!player.playerId) continue;
            
//     //         await TriggerPresentation('show_player', player.playerId);
//     //         // Esperar el tiempo maestro (ej. 10s)
//     //         await new Promise(resolve => setTimeout(resolve, presentationTime * 1000));
//     //     }

//     //     // Al final, presentamos al DT
//     //     await TriggerPresentation('show_dt', null);
//     //     await new Promise(resolve => setTimeout(resolve, presentationTime * 1000));

//     //     // Cerramos el telón
//     //     await TriggerPresentation('close', null);
//     //     setIsSequenceRunning(false);
//     //     showMessage("Secuencia Finalizada", MESSAGE_TYPE.SUCCESS);
//     // };

//     // --- MACRO: SECUENCIA AUTOMÁTICA DE TV ---
//     const runFullSequence = async () => {
//         if (sequenceRunningRef.current) return;
        
//         sequenceRunningRef.current = true;
//         setIsSequenceRunning(true);
//         showMessage("Secuencia Automática Iniciada", MESSAGE_TYPE.SUCCESS);

//         const sortedPlayers = [...pitchPlayers].sort((a, b) => a.positionX - b.positionX);

//         for (let player of sortedPlayers) {
//             if (!sequenceRunningRef.current) break; // Si se canceló, rompemos el ciclo
//             if (!player.playerId) continue;
            
//             await TriggerPresentation('show_player', player.playerId);
            
//             // Esperamos segundo a segundo para poder cancelarlo a la mitad
//             for(let i = 0; i < presentationTime; i++) {
//                 if (!sequenceRunningRef.current) break;
//                 await new Promise(resolve => setTimeout(resolve, 1000));
//             }
//         }

//         if (sequenceRunningRef.current) {
//             await TriggerPresentation('show_dt', null);
//             for(let i = 0; i < presentationTime; i++) {
//                 if (!sequenceRunningRef.current) break;
//                 await new Promise(resolve => setTimeout(resolve, 1000));
//             }
//         }

//         if (sequenceRunningRef.current) {
//             await TriggerPresentation('close', null);
//             showMessage("Secuencia Finalizada", MESSAGE_TYPE.SUCCESS);
//         }

//         sequenceRunningRef.current = false;
//         setIsSequenceRunning(false);
//     };

//     const abortSequence = async () => {
//         sequenceRunningRef.current = false; // Detiene el ciclo for instantáneamente
//         setIsSequenceRunning(false);
//         await TriggerPresentation('close', null); // Envía la orden de cierre al overlay
//         showMessage("Presentación abortada", MESSAGE_TYPE.WARNING);
//     };

//     // -------------------------------------------------------------------------
//     // RENDERIZADO DEL PANEL
//     // -------------------------------------------------------------------------
//     return (
//         <SecondaryBase actionToExecute={getOutOfTheDynamic}>
//             <div className="container-fluid pb-5">
//                 <div className="text-center mb-4">
//                     <h3 className="fw-bold"><i className="bi bi-diagram-3-fill"></i> Panel del Operador: Alineación Oficial</h3>
//                     <p className="text-muted small">Configura la táctica y lanza la presentación estelar a la pantalla.</p>
//                 </div>

//                 <div className="row g-4">
//                     {/* COLUMNA IZQUIERDA: Configuración */}
//                     <div className="col-lg-4">
//                         <div className="card shadow-sm border-0 rounded-4 mb-4">
//                             <div className="card-header bg-dark text-white fw-bold"><i className="bi bi-gear-fill"></i> Configuración Base</div>
//                             <div className="card-body">
//                                 <div className="mb-3">
//                                     <label className="form-label small fw-bold">Tipo de Equipo</label>
//                                     <select className="form-select" value={teamType} onChange={(e) => setTeamType(e.target.value)}>
//                                         <option value="Local">Local</option>
//                                         <option value="Away">Visitante</option>
//                                     </select>
//                                 </div>
//                                 <div className="mb-3">
//                                     <label className="form-label small fw-bold">Seleccionar Equipo de BD</label>
//                                     <select className="form-select" value={teamId} onChange={(e) => handleTeamChange(e.target.value)}>
//                                         <option value="">-- Elige un equipo --</option>
//                                         {teams.map(t => <option key={t.id} value={t.id}>{t.name}</option>)}
//                                     </select>
//                                 </div>
//                                 <div className="mb-3">
//                                     <label className="form-label small fw-bold">Formación Táctica</label>
//                                     <select className="form-select" value={formation} onChange={(e) => applyFormationTemplate(e.target.value)}>
//                                         {Object.keys(FORMATIONS).map(f => <option key={f} value={f}>{f}</option>)}
//                                     </select>
//                                 </div>
//                                 <div className="row g-2 mb-3">
//                                     <div className="col-6">
//                                         <label className="form-label small fw-bold">Color Uniforme</label>
//                                         <input type="color" className="form-control form-control-color w-100" value={kitColor} onChange={(e) => setKitColor(e.target.value)} />
//                                     </div>
//                                     <div className="col-6">
//                                         <label className="form-label small fw-bold">Nombre del DT</label>
//                                         {/* <input type="text" className="form-control" value={managerName} onChange={(e) => setManagerName(e.target.value)} placeholder="Ej. Guardiola" /> */}
//                                         <input 
//                                             type="text" 
//                                             className="form-control" 
//                                             value={managerName} // Esto asegura que el input siempre muestre el valor actual
//                                             onChange={(e) => setManagerName(e.target.value)} 
//                                             placeholder="Ej. Guardiola" 
//                                         />
//                                     </div>
//                                 </div>
//                                 <button className="btn btn-success w-100 fw-bold shadow-sm" onClick={handleSave}>
//                                     <i className="bi bi-cloud-arrow-up-fill"></i> Guardar y Sincronizar Pantalla
//                                 </button>
//                             </div>
//                         </div>

//                         {/* PANEL DE SECUENCIA TV */}
//                         <div className="card shadow-sm border-0 rounded-4 bg-light border border-warning">
//                             <div className="card-body text-center">
//                                 <h6 className="fw-bold text-warning mb-3"><i className="bi bi-camera-video-fill"></i> Máster de Transmisión</h6>
//                                 <div className="d-flex align-items-center justify-content-center gap-2 mb-3">
//                                     <span className="small fw-bold text-muted">Duración por jugador (s):</span>
//                                     <input type="number" className="form-control text-center w-25" value={presentationTime} onChange={(e) => setPresentationTime(e.target.value)} min="5" max="20" />
//                                 </div>
//                                 <button 
//                                     className={`btn w-100 fw-bold ${isSequenceRunning ? 'btn-danger' : 'btn-warning'}`} 
//                                     onClick={runFullSequence}
//                                     disabled={isSequenceRunning || pitchPlayers.length === 0}
//                                 >
//                                     {isSequenceRunning ? <><i className="bi bi-hourglass-split"></i> Secuencia en Curso...</> : <><i className="bi bi-play-circle-fill"></i> Lanzar Secuencia Automática TV</>}
//                                 </button>
//                                 {/* <button className="btn btn-outline-danger w-100 fw-bold mt-2 btn-sm" onClick={() => firePresentation('close')}>
//                                     <i className="bi bi-x-circle-fill"></i> Forzar Cierre de Presentación
//                                 </button> */}
//                                 <button className="btn btn-outline-danger w-100 fw-bold mt-2 btn-sm" onClick={abortSequence}>
//                                     <i className="bi bi-x-circle-fill"></i> Detener y Forzar Cierre
//                                 </button>
//                             </div>
//                         </div>
//                     </div>

//                     {/* COLUMNA DERECHA: Pizarra Táctica */}
//                     <div className="col-lg-8">
//                         <div className="card shadow-sm border-0 rounded-4 h-100">
//                             <div className="card-header bg-success text-white fw-bold d-flex justify-content-between align-items-center">
//                                 <span><i className="bi bi-clipboard-data-fill"></i> Pizarra de Titulares (Drag & Drop)</span>
//                                 <span className="badge bg-dark">Ataca hacia: {teamType === 'Local' ? 'Derecha ➡' : '⬅ Izquierda'}</span>
//                             </div>
//                             <div className="card-body bg-dark text-white rounded-bottom position-relative" style={{ minHeight: '500px', overflow: 'hidden' }}>
                                
//                                 {/* Representación de la Cancha */}
//                                 <div className="position-absolute border border-white opacity-25" style={{ top: '10%', bottom: '10%', left: '5%', right: '5%' }}>
//                                     <div className="position-absolute h-100 border-end border-white" style={{ left: '50%' }}></div>
//                                     <div className="position-absolute border border-white rounded-circle" style={{ width: '100px', height: '100px', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}></div>
//                                 </div>

//                                 {/* Renderizado de Posiciones (Los 11 huecos) */}
//                                 {pitchPlayers.map((player, idx) => (
//                                     <div 
//                                         key={idx}
//                                         draggable
//                                         onDragStart={(e) => handleDragStart(e, idx)}
//                                         onDragOver={(e) => e.preventDefault()}
//                                         onDrop={(e) => handleDrop(e, idx)}
//                                         className="position-absolute d-flex flex-column align-items-center"
//                                         style={{ 
//                                             left: `${player.positionX}%`, top: `${player.positionY}%`, 
//                                             transform: 'translate(-50%, -50%)', cursor: 'grab', zIndex: 10 
//                                         }}
//                                     >
//                                         <div className="rounded-circle d-flex align-items-center justify-content-center shadow" style={{ width: '35px', height: '35px', backgroundColor: kitColor, border: '2px solid white', color: 'white', fontWeight: 'bold', fontSize: '0.9rem', position: 'relative' }}>
//                                             {player.dorsal || '#'}
//                                             {player.isCaptain && <span className="position-absolute bg-warning text-dark rounded-circle" style={{ width: '14px', height: '14px', fontSize: '0.6rem', bottom: '-2px', right: '-2px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>C</span>}
//                                         </div>
                                        
//                                         {/* Selector del Jugador */}
//                                         <div className="mt-1 bg-secondary rounded px-1 shadow-sm" style={{ minWidth: '100px' }}>
//                                             <select 
//                                                 className="form-select form-select-sm border-0 bg-transparent text-white text-center p-0" 
//                                                 style={{ fontSize: '0.75rem', fontWeight: 'bold', boxShadow: 'none' }}
//                                                 value={player.playerId} 
//                                                 onChange={(e) => updatePitchPlayer(idx, e.target.value)}
//                                             >
//                                                 <option value="" className="text-dark">Seleccionar...</option>
//                                                 {availablePlayers.map(ap => (
//                                                     <option key={ap.id} value={ap.id} className="text-dark">{ap.dorsal} - {ap.name}</option>
//                                                 ))}
//                                             </select>
//                                         </div>
                                        
//                                         {/* Acciones individuales */}
//                                         <div className="d-flex gap-1 mt-1 opacity-75">
//                                             <button className="btn btn-sm btn-outline-warning p-0 px-1" style={{ fontSize: '0.6rem' }} onClick={() => setCaptain(idx)} title="Hacer Capitán">©</button>
//                                             <button className="btn btn-sm btn-outline-info p-0 px-1" style={{ fontSize: '0.6rem' }} onClick={() => firePresentation('show_player', player.playerId)} disabled={!player.playerId} title="Presentar en Pantalla"><i className="bi bi-play-fill"></i></button>
//                                         </div>
//                                     </div>
//                                 ))}

//                                 {/* DT CARD (Fuera del campo de juego interactivo) */}
//                                 <div className="position-absolute bottom-0 start-0 p-3">
//                                     <button className="btn btn-sm btn-outline-light d-flex align-items-center gap-2" onClick={() => firePresentation('show_dt')}>
//                                         <div className="rounded-circle bg-secondary d-flex align-items-center justify-content-center" style={{ width: '25px', height: '25px', fontSize: '0.7rem' }}>DT</div>
//                                         Presentar a: {managerName}
//                                     </button>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </SecondaryBase>
//     );
// };

// export { Lineup };